var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolutionPageHealthInsurancePartImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 598,
    viewBox: "0 0 500 598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -31.183,
    y1: -0.05,
    x2: -33.492,
    y2: 3.119,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -27.057,
    y1: -0.462,
    x2: -29.893,
    y2: 5.914,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -114.03,
    y1: 0.5,
    x2: -113.03,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -23.841,
    y1: -0.033,
    x2: -25.915,
    y2: 0.806,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2355cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c246d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -72.31,
    y1: -2.205,
    x2: -79.408,
    y2: 5.347,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -140.574,
    y1: 0.5,
    x2: -139.574,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -11.251,
    y1: 0.249,
    x2: -12.171,
    y2: 1.488,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -19.904,
    y1: 0.5,
    x2: -18.904,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -135.833,
    y1: 0.707,
    x2: -133.777,
    y2: -1.067,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -18.976,
    y1: 0.5,
    x2: -17.976,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -57.175,
    y1: 0.5,
    x2: -56.175,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -45.64,
    y1: 0.5,
    x2: -44.64,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -54.757,
    y1: -26.801,
    x2: -54.55,
    y2: -25.632,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Instagram_Story_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 598
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram_Story_53",
    "data-name": "Instagram Story \\u2013 53",
    clipPath: "url(#clip-Instagram_Story_53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10009",
    "data-name": "Group 10009",
    transform: "translate(-15.663 -34.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(15.663 99.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(57.999 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4739",
    "data-name": "Rectangle 4739",
    width: 87.819,
    height: 167.57,
    rx: 5.21,
    transform: "translate(0 211.539) rotate(-26.88)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 6.414,
    cy: 6.414,
    r: 6.414,
    transform: "matrix(0.83, -0.558, 0.558, 0.83, 26.047, 225.665)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_530",
    "data-name": "Ellipse 530",
    cx: 6.434,
    cy: 6.434,
    r: 6.434,
    transform: "matrix(0.937, -0.349, 0.349, 0.937, 60.491, 207.207)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4948",
    "data-name": "Path 4948",
    d: "M56.943,260.806a6.414,6.414,0,1,1-3.729-3.2,6.414,6.414,0,0,1,3.729,3.2Z",
    transform: "translate(-0.572 -5.338)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_531",
    "data-name": "Ellipse 531",
    cx: 6.414,
    cy: 6.414,
    r: 6.414,
    transform: "translate(77.329 247.674) rotate(-88.06)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4949",
    "data-name": "Path 4949",
    d: "M72.963,292.426a6.414,6.414,0,1,1-8.617-2.82,6.414,6.414,0,0,1,8.617,2.82Z",
    transform: "translate(-0.904 -5.994)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4950",
    "data-name": "Path 4950",
    d: "M106.983,275.186a6.424,6.424,0,1,1-8.627-2.82A6.424,6.424,0,0,1,106.983,275.186Z",
    transform: "translate(-1.609 -5.636)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4951",
    "data-name": "Path 4951",
    d: "M88.993,324.046a6.414,6.414,0,1,1-8.627-2.82,6.414,6.414,0,0,1,8.627,2.82Z",
    transform: "translate(-1.236 -6.65)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4952",
    "data-name": "Path 4952",
    d: "M123,306.806a6.414,6.414,0,1,1-3.729-3.2,6.414,6.414,0,0,1,3.729,3.2Z",
    transform: "translate(-1.942 -6.292)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4953",
    "data-name": "Path 4953",
    d: "M37.117,226.27a34.96,34.96,0,0,1-1.7,5.8,36.87,36.87,0,0,1-2.194,5.689,35.2,35.2,0,0,1,1.743-5.876,35.341,35.341,0,0,1,2.154-5.611Z",
    transform: "translate(-0.331 -4.694)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4954",
    "data-name": "Path 4954",
    d: "M70.387,209.1a37.116,37.116,0,0,1-1.714,5.778,35.339,35.339,0,0,1-2.194,5.631,36.849,36.849,0,0,1,1.714-5.8,35.7,35.7,0,0,1,2.194-5.611Z",
    transform: "translate(-1.021 -4.338)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4955",
    "data-name": "Path 4955",
    d: "M53.481,257.84a37.064,37.064,0,0,1-1.381,6.032,37.721,37.721,0,0,1-1.88,5.876,37.79,37.79,0,0,1,1.391-6.032,39.68,39.68,0,0,1,1.87-5.876Z",
    transform: "translate(-0.684 -5.349)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4956",
    "data-name": "Path 4956",
    d: "M87.063,240.59a34.156,34.156,0,0,1-1.107,5.876,35.05,35.05,0,0,1-1.6,5.729,33.982,33.982,0,0,1,1.107-5.876,35.05,35.05,0,0,1,1.6-5.729Z",
    transform: "translate(-1.392 -4.991)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4957",
    "data-name": "Path 4957",
    d: "M68.426,289.47A31.618,31.618,0,0,1,67.163,295a31.113,31.113,0,0,1-1.763,5.386,33.412,33.412,0,0,1,1.273-5.5A33.02,33.02,0,0,1,68.426,289.47Z",
    transform: "translate(-0.999 -6.005)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4958",
    "data-name": "Path 4958",
    d: "M103.377,272.68a33.707,33.707,0,0,1-1.714,5.494,31.334,31.334,0,0,1-2.184,5.317,33.883,33.883,0,0,1,1.7-5.494A31.776,31.776,0,0,1,103.377,272.68Z",
    transform: "translate(-1.706 -5.657)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4959",
    "data-name": "Path 4959",
    d: "M85.47,321.42a36.71,36.71,0,0,1-1.88,5.719,35.567,35.567,0,0,1-2.35,5.533,36.082,36.082,0,0,1,1.87-5.709,35.389,35.389,0,0,1,2.36-5.543Z",
    transform: "translate(-1.327 -6.668)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4960",
    "data-name": "Path 4960",
    d: "M119.272,303.13a42.531,42.531,0,0,1-1.351,6.4,42.423,42.423,0,0,1-1.851,6.277,42.53,42.53,0,0,1,1.351-6.4,41.5,41.5,0,0,1,1.851-6.277Z",
    transform: "translate(-2.05 -6.289)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4961",
    "data-name": "Path 4961",
    d: "M134.521,323.3c.059.127-10.125,5.415-22.748,11.82S88.859,346.606,88.79,346.508s10.125-5.445,22.728-11.849S134.453,323.173,134.521,323.3Z",
    transform: "translate(-1.484 -6.707)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4962",
    "data-name": "Path 4962",
    d: "M67.031,196.61c.069.127-10.116,5.415-22.748,11.82S21.369,219.916,21.3,219.789s10.125-5.415,22.758-11.82S66.972,196.492,67.031,196.61Z",
    transform: "translate(-0.084 -4.079)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4963",
    "data-name": "Path 4963",
    d: "M46.294,215a.49.49,0,0,1-.186,0H46l.45-.235h0a.25.25,0,0,1-.147.264c-.147.069-.264.049-.3,0h0l.45-.235h0a.186.186,0,0,1,0,.069.431.431,0,0,1-.157.137Z",
    transform: "translate(-0.596 -4.455)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4964",
    "data-name": "Path 4964",
    d: "M109.167,333c-.127.069-14.424-27.889-31.933-62.437s-31.6-62.613-31.473-62.672,14.415,27.889,31.933,62.437S109.294,332.941,109.167,333Z",
    transform: "translate(-0.591 -4.313)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4965",
    "data-name": "Path 4965",
    d: "M13.575,355.528c-.118,21.935-.2,57.355-.225,73.63a8.686,8.686,0,0,0,8.657,8.715l59.921.274a8.715,8.715,0,0,0,8.745-8.666L91,356.5a19.33,19.33,0,0,0-19.242-19.419h0V326.307l-39.17-.137-.049,10.145H32.4A19.321,19.321,0,0,0,13.575,355.528Z",
    transform: "translate(0.081 -6.767)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4966",
    "data-name": "Path 4966",
    d: "M32.98,327.56l-.02,4.886,39.229,1.567.029-6.267Z",
    transform: "translate(-0.326 -6.796)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4967",
    "data-name": "Path 4967",
    d: "M2.928,0H45.477a2.938,2.938,0,0,1,2.938,2.938V17.627a1.89,1.89,0,0,1-1.89,1.89H1.89A1.89,1.89,0,0,1,0,17.627V2.938A2.938,2.938,0,0,1,2.938,0Z",
    transform: "translate(28.225 304.436) rotate(0.26)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4968",
    "data-name": "Path 4968",
    d: "M34.68,330.439c-.284,0-.49-4.338-.47-9.695s.274-9.695.558-9.695.5,4.348.47,9.695S34.984,330.439,34.68,330.439Z",
    transform: "translate(-0.352 -6.453)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4969",
    "data-name": "Path 4969",
    d: "M39.99,330.459c-.284,0-.49-4.338-.47-9.695s.274-9.695.558-9.695.5,4.348.47,9.7S40.245,330.469,39.99,330.459Z",
    transform: "translate(-0.462 -6.454)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4970",
    "data-name": "Path 4970",
    d: "M45.24,330.489c-.284,0-.49-4.348-.47-9.695s.274-9.695.558-9.695.5,4.338.47,9.695S45.524,330.489,45.24,330.489Z",
    transform: "translate(-0.571 -6.454)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4971",
    "data-name": "Path 4971",
    d: "M50.52,330.509c-.284,0-.49-4.338-.47-9.695s.274-9.695.558-9.695.5,4.348.47,9.7S50.8,330.509,50.52,330.509Z",
    transform: "translate(-0.68 -6.455)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4972",
    "data-name": "Path 4972",
    d: "M55.8,330.589c-.284,0-.49-4.348-.47-9.695s.274-9.695.558-9.695.5,4.338.47,9.695S56.084,330.589,55.8,330.589Z",
    transform: "translate(-0.79 -6.456)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4973",
    "data-name": "Path 4973",
    d: "M61.08,330.589c-.284,0-.49-4.338-.47-9.695s.274-9.695.558-9.695.5,4.348.47,9.695S61.364,330.589,61.08,330.589Z",
    transform: "translate(-0.899 -6.456)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4974",
    "data-name": "Path 4974",
    d: "M66.36,330.589c-.284,0-.49-4.348-.47-9.7s.274-9.695.558-9.685.5,4.338.47,9.695S66.644,330.589,66.36,330.589Z",
    transform: "translate(-1.009 -6.456)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4975",
    "data-name": "Path 4975",
    d: "M71.64,330.589c-.284,0-.49-4.348-.47-9.695s.274-9.695.558-9.695.5,4.338.47,9.695S71.924,330.589,71.64,330.589Z",
    transform: "translate(-1.118 -6.456)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4740",
    "data-name": "Rectangle 4740",
    width: 56.219,
    height: 37.182,
    rx: 1.48,
    transform: "translate(24.578 359.384) rotate(0.26)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4976",
    "data-name": "Path 4976",
    d: "M77.075,401.909a3.113,3.113,0,0,1,0-.627c0-.46,0-1.028,0-1.733,0-1.6,0-3.78-.078-6.522,0-5.68-.059-13.71-.108-23.4l.411.411-49.315-.117.509-.509h0v8.48c0,2.791,0,5.543-.049,8.245,0,5.4-.069,10.6-.1,15.541l-.47-.48,35.361.4,10.194.167,2.742.078a6.939,6.939,0,0,1,.979.059,5.436,5.436,0,0,1-.872.049H73.628l-10.086.078-35.674.069H27.4V369.349h0c-.46.45.627-.637.519-.519l49.276.333H77.6v.411c-.137,9.793-.245,17.911-.323,23.649q-.088,4.064-.137,6.434v1.655a2.84,2.84,0,0,1-.069.6Z",
    transform: "translate(-0.208 -7.652)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4977",
    "data-name": "Path 4977",
    d: "M69.731,380.267c0,.284-7.5.48-16.745.431s-16.735-.3-16.735-.588,7.491-.48,16.745-.441S69.731,379.993,69.731,380.267Z",
    transform: "translate(-0.394 -7.877)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4978",
    "data-name": "Path 4978",
    d: "M69.71,386.077c0,.284-7.5.48-16.745.441s-16.745-.313-16.745-.6,7.5-.48,16.745-.431S69.71,385.793,69.71,386.077Z",
    transform: "translate(-0.393 -7.997)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4979",
    "data-name": "Path 4979",
    d: "M69.681,391.657c0,.294-7.5.49-16.745.441s-16.745-.3-16.735-.588,7.491-.48,16.745-.441S69.681,391.373,69.681,391.657Z",
    transform: "translate(-0.393 -8.113)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4980",
    "data-name": "Path 4980",
    d: "M69.946,336.987c0,.284-8.187.48-18.283.431s-18.273-.313-18.273-.6,8.187-.48,18.283-.431S69.946,336.664,69.946,336.987Z",
    transform: "translate(-0.335 -6.979)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4981",
    "data-name": "Path 4981",
    d: "M16.664,425.24a23.169,23.169,0,0,1-.176-3.457c0-2.4-.059-5.572-.088-9.42,0-7.952,0-18.939.078-31.072.059-6.062.118-11.829.166-17.108s.588-10.135,2.331-13.837a15.2,15.2,0,0,1,6.257-7.07,11.039,11.039,0,0,1,2.409-.979,2.554,2.554,0,0,1,.891-.117,20.119,20.119,0,0,0-3.1,1.42,15.4,15.4,0,0,0-5.787,7.021c-1.6,3.594-2.047,8.333-2.047,13.553s-.059,11.046-.088,17.108c-.088,12.133-.225,23.12-.382,31.072-.1,3.839-.176,7.021-.235,9.411a22.876,22.876,0,0,1-.225,3.476Z",
    transform: "translate(0.018 -7.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4982",
    "data-name": "Path 4982",
    d: "M88.013,437.539a14.6,14.6,0,0,1-2.683-.852c-.852-.313-1.89-.686-3.124-1.048s-2.6-.862-4.172-1.244a98.025,98.025,0,0,0-11.066-2.37,104.4,104.4,0,0,0-13.788-1.048,103.821,103.821,0,0,0-13.807.979,96.619,96.619,0,0,0-11.085,2.262c-1.567.372-2.938.852-4.181,1.214s-2.272.715-3.124.979a14.794,14.794,0,0,1-2.693.823,14.1,14.1,0,0,1,2.556-1.195,31.759,31.759,0,0,1,3.085-1.195,43.439,43.439,0,0,1,4.162-1.361,83.873,83.873,0,0,1,11.144-2.507,96.1,96.1,0,0,1,13.954-1.048,96.612,96.612,0,0,1,13.935,1.175,85.086,85.086,0,0,1,11.115,2.6c1.567.431,2.938.979,4.162,1.4s2.243.852,3.075,1.224a13.985,13.985,0,0,1,2.536,1.214Z",
    transform: "translate(-0.021 -8.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4983",
    "data-name": "Path 4983",
    d: "M449.635,117.787c-1.107-6.473-6.855-12.29-13.455-11.986a14.4,14.4,0,0,0-9.988,5.317,26.277,26.277,0,0,0-2.438,3.192,26.442,26.442,0,0,0-2.1-3.427,14.4,14.4,0,0,0-9.371-6.346c-6.492-.979-12.858,4.181-14.64,10.507s.264,13.22,3.917,18.674a37.076,37.076,0,0,0,20.868,15.668c7.413-1.3,17.1-8.382,21.318-13.406S450.741,124.26,449.635,117.787Z",
    transform: "translate(-7.878 -2.166)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4984",
    "data-name": "Path 4984",
    d: "M447.839,129.874h-.872l-2.438-.088-8.96-.4.157-.108c-.979,2.859-2.056,6.2-3.271,9.861l-.2.6-.176-.6-4.456-15.355c-.49-1.7-.979-3.378-1.449-5l.382.059c-2.262,3.447-4.416,6.708-6.375,9.675l-.059.1h-.108l-15.756-.911-4.456-.294-1.185-.088a1.87,1.87,0,0,1-.4,0,1.636,1.636,0,0,1,.411,0h1.175l4.465.186,15.766.754-.176.078,6.346-9.695.255-.392.127.45c.47,1.626.979,3.3,1.449,5l4.426,15.355h-.372c1.234-3.662,2.37-6.992,3.339-9.841V129.1h.118l8.95.539,2.468.118.627.049Z",
    transform: "translate(-7.904 -2.453)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4985",
    "data-name": "Path 4985",
    d: "M339,150.371a2.21,2.21,0,0,1,.382-.274l1.136-.754a16.8,16.8,0,0,0,1.821-1.273,25.455,25.455,0,0,0,2.37-1.89L346.07,145l1.4-1.42a21.274,21.274,0,0,0,1.459-1.6c.48-.578,1.028-1.146,1.488-1.8a42.108,42.108,0,0,0,5.582-9.44,41.647,41.647,0,0,0,3.251-12.838,39.81,39.81,0,0,0,0-7.4,73.455,73.455,0,0,0-1.342-7.746c-1.107-5.259-2.6-10.87-2.145-16.843s2.82-11.751,5.973-17.166a51.556,51.556,0,0,1,11.467-14.16,28.3,28.3,0,0,1,7.462-4.475,32.786,32.786,0,0,1,8.108-2.017,99.306,99.306,0,0,1,15.365-.245,69.312,69.312,0,0,0,13.308-.548,26.616,26.616,0,0,0,10.243-3.682,20.133,20.133,0,0,0,5.983-5.631,14.835,14.835,0,0,0,2.213-4.72c.3-1.156.362-1.792.4-1.782A10.329,10.329,0,0,1,436,33.292,14.357,14.357,0,0,1,433.86,38.1a20.271,20.271,0,0,1-6,5.778,26.93,26.93,0,0,1-10.4,3.78,69.881,69.881,0,0,1-13.377.607,101.029,101.029,0,0,0-15.3.294,32.393,32.393,0,0,0-7.971,1.958,27.741,27.741,0,0,0-7.315,4.407,52.263,52.263,0,0,0-11.33,14.023c-3.153,5.347-5.474,11.085-5.876,16.931s.979,11.418,2.105,16.647a73.462,73.462,0,0,1,1.322,7.834,40.713,40.713,0,0,1,0,7.491,42.451,42.451,0,0,1-9.048,22.425c-.47.666-1.028,1.224-1.518,1.8a19.677,19.677,0,0,1-1.488,1.6l-1.43,1.41-1.381,1.175a28,28,0,0,1-2.409,1.861,16.73,16.73,0,0,1-1.851,1.234l-1.175.705a3.783,3.783,0,0,1-.421.313Z",
    transform: "translate(-6.675 -0.653)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4986",
    "data-name": "Path 4986",
    d: "M311.78,123.229s.059-.157.2-.441.362-.725.627-1.273.7-1.2,1.155-1.959a23.9,23.9,0,0,1,1.8-2.575,36.027,36.027,0,0,1,22.268-13.651,48.128,48.128,0,0,1,7.178-.666c4.975-.147,10.272.264,15.815-.069a38.5,38.5,0,0,0,8.373-1.41,36.516,36.516,0,0,0,8.118-3.516,41.06,41.06,0,0,0,13.406-12.73A46.475,46.475,0,0,0,397.572,67.7a56.456,56.456,0,0,0,.48-17.352c-.705-5.513-2.047-10.654-2.82-15.57a39.768,39.768,0,0,1-.2-13.8,29.681,29.681,0,0,1,4.309-10.527,30.354,30.354,0,0,1,5.68-6.532A29.857,29.857,0,0,1,409.48.842L410.743.2l.431-.2s-.127.088-.411.245l-1.234.734a33.066,33.066,0,0,0-4.377,3.173,30.162,30.162,0,0,0-5.562,6.463A29.437,29.437,0,0,0,395.4,21.054a39.513,39.513,0,0,0,.264,13.651c.793,4.9,2.154,10.018,2.869,15.58a56.8,56.8,0,0,1-.45,17.509,46.887,46.887,0,0,1-6.9,17.4,41.658,41.658,0,0,1-13.573,12.916,36.456,36.456,0,0,1-8.245,3.545,38.485,38.485,0,0,1-8.48,1.42c-5.6.323-10.9-.108-15.844,0a48.5,48.5,0,0,0-7.109.617,36.017,36.017,0,0,0-22.17,13.377c-.754.9-1.312,1.792-1.841,2.526a19.28,19.28,0,0,0-1.195,1.959c-.3.539-.509.979-.676,1.234S311.78,123.229,311.78,123.229Z",
    transform: "translate(-6.11)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4987",
    "data-name": "Path 4987",
    d: "M400.85,10.32a11.361,11.361,0,0,1,1.508.872c.979.588,2.3,1.479,3.917,2.615a153.478,153.478,0,0,1,12.348,9.567,149.25,149.25,0,0,1,11.3,10.772c1.371,1.459,2.448,2.664,3.173,3.516a9.924,9.924,0,0,1,1.087,1.351A10.261,10.261,0,0,1,432.94,37.8l-3.281-3.31c-2.8-2.84-6.767-6.669-11.369-10.644s-8.99-7.315-12.221-9.665l-3.829-2.761a11.608,11.608,0,0,1-1.391-1.1Z",
    transform: "translate(-7.958 -0.214)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4988",
    "data-name": "Path 4988",
    d: "M396.9,21a7.24,7.24,0,0,1,1.077.979l2.938,2.82c2.478,2.38,5.944,5.621,9.91,9.039s7.677,6.385,10.39,8.48c1.293.979,2.37,1.841,3.222,2.487a8.37,8.37,0,0,1,1.146.979A8.246,8.246,0,0,1,424.309,45c-.8-.539-1.958-1.332-3.329-2.35-2.781-2.027-6.541-4.9-10.517-8.373s-7.413-6.727-9.793-9.176c-1.2-1.224-2.164-2.242-2.81-2.938A7.674,7.674,0,0,1,396.9,21Z",
    transform: "translate(-7.876 -0.436)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4989",
    "data-name": "Path 4989",
    d: "M398.22,34.11a16.743,16.743,0,0,1,2.517,1.851c1.508,1.2,3.564,2.938,5.768,4.9s4.162,3.76,5.552,5.1a16.082,16.082,0,0,1,2.145,2.272,18.833,18.833,0,0,1-2.409-1.959l-5.65-4.975-5.65-4.975A17.627,17.627,0,0,1,398.22,34.11Z",
    transform: "translate(-7.904 -0.708)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4990",
    "data-name": "Path 4990",
    d: "M388.29,49.85a10.468,10.468,0,0,1,1.91,1.41l4.465,3.555,4.495,3.5a10.294,10.294,0,0,1,1.812,1.537,10.1,10.1,0,0,1-2.037-1.214c-1.214-.823-2.859-1.959-4.612-3.388s-3.29-2.7-4.377-3.692a9.352,9.352,0,0,1-1.655-1.7Z",
    transform: "translate(-7.698 -1.034)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4991",
    "data-name": "Path 4991",
    d: "M376.5,54.61c.059-.059,1.214,1.067,3.134,2.81s4.622,4.093,7.775,6.492,6.13,4.387,8.324,5.778a39.663,39.663,0,0,1,3.535,2.272,4.6,4.6,0,0,1-1.028-.46c-.656-.323-1.586-.832-2.712-1.479a84.214,84.214,0,0,1-8.461-5.67,82.781,82.781,0,0,1-7.707-6.649c-.93-.911-1.655-1.665-2.145-2.213A4.057,4.057,0,0,1,376.5,54.61Z",
    transform: "translate(-7.453 -1.133)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4992",
    "data-name": "Path 4992",
    d: "M369,63.57c.1-.118,5.8,4.093,12.73,9.42s12.5,9.734,12.4,9.861-5.787-4.1-12.73-9.42S368.931,63.687,369,63.57Z",
    transform: "translate(-7.297 -1.319)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4993",
    "data-name": "Path 4993",
    d: "M360,71.69a7.314,7.314,0,0,1,1.116.8l2.938,2.331c2.468,1.959,5.876,4.651,9.734,7.54s7.384,5.415,9.969,7.237l3.046,2.154a5.962,5.962,0,0,1,1.077.842,6.856,6.856,0,0,1-1.195-.666c-.754-.46-1.831-1.146-3.153-2.017-2.634-1.733-6.218-4.221-10.077-7.109s-7.246-5.64-9.646-7.687c-1.2-.979-2.164-1.861-2.81-2.458a6.2,6.2,0,0,1-1-.969Z",
    transform: "translate(-7.111 -1.487)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4994",
    "data-name": "Path 4994",
    d: "M357.23,83.38c.088-.118,4.9,3.457,10.772,7.991s10.576,8.314,10.488,8.431-4.945-3.457-10.821-7.991S357.132,83.5,357.23,83.38Z",
    transform: "translate(-7.053 -1.73)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4995",
    "data-name": "Path 4995",
    d: "M354.62,95.58a48.962,48.962,0,0,1,6.306,3.917,50.028,50.028,0,0,1,5.993,4.338,51.2,51.2,0,0,1-6.306-3.917,50.921,50.921,0,0,1-5.993-4.338Z",
    transform: "translate(-6.999 -1.983)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4996",
    "data-name": "Path 4996",
    d: "M342,107.24a17.008,17.008,0,0,1,2.83,1.6c1.7,1.067,4.015,2.6,6.5,4.387s4.691,3.486,6.248,4.759a18.732,18.732,0,0,1,2.429,2.164,20.856,20.856,0,0,1-2.673-1.861c-1.606-1.195-3.839-2.84-6.316-4.622s-4.759-3.359-6.4-4.495A21.111,21.111,0,0,1,342,107.24Z",
    transform: "translate(-6.737 -2.225)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4997",
    "data-name": "Path 4997",
    d: "M331,107.44a6.248,6.248,0,0,1,1.146.774c.705.529,1.714,1.322,2.938,2.311,2.477,1.959,5.817,4.8,9.391,8.059s6.688,6.316,8.892,8.6c1.107,1.136,1.959,2.066,2.575,2.722a8.284,8.284,0,0,1,.881,1.058,5.759,5.759,0,0,1-1.038-.911l-2.693-2.6c-2.272-2.2-5.425-5.219-8.99-8.471s-6.855-6.111-9.264-8.157L332,108.39A7.833,7.833,0,0,1,331,107.44Z",
    transform: "translate(-6.509 -2.229)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4998",
    "data-name": "Path 4998",
    d: "M321.73,115.65a7.551,7.551,0,0,1,1.234.852c.764.588,1.861,1.449,3.212,2.526,2.683,2.145,6.355,5.17,10.351,8.6s7.53,6.59,10.067,8.921c1.273,1.165,2.291,2.125,2.938,2.791a7.453,7.453,0,0,1,1.038,1.087,8.4,8.4,0,0,1-1.156-.93l-3.094-2.664-10.174-8.813-10.233-8.7-3.094-2.654A8.422,8.422,0,0,1,321.73,115.65Z",
    transform: "translate(-6.317 -2.399)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4999",
    "data-name": "Path 4999",
    d: "M303.76,13.652a14.787,14.787,0,0,1,5.347,10.3,26.117,26.117,0,0,1-1.861,11.673c-2.683,7.217-8.764,13.661-14.787,18.459-4.9-7.011-3.917-16.882-3.173-21.867,1.244-7.834,8.275-21.328,14.473-18.606",
    transform: "translate(-5.631 -0.275)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5000",
    "data-name": "Path 5000",
    d: "M296.84,69.038a12.642,12.642,0,0,1,6.855-10.674A16.775,16.775,0,0,1,316.64,57.6c1.958.656,3.917,1.763,4.691,3.682a5.425,5.425,0,0,1-1.244,5.347,10.987,10.987,0,0,1-4.9,2.938c-6.257,2.056-12.73,2.889-18.361-.48",
    transform: "translate(-5.8 -1.175)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5001",
    "data-name": "Path 5001",
    d: "M284.92,84.563a25.02,25.02,0,0,1,2.037-4.7A23.5,23.5,0,0,1,290.1,75.27a52.06,52.06,0,0,1,4.691-4.945,25.373,25.373,0,0,1,10.772-5.876,18.82,18.82,0,0,1,3.721-.48,3.917,3.917,0,0,1,1.371.118c0,.157-1.958.108-4.9.979A27.125,27.125,0,0,0,295.4,71.03a59.856,59.856,0,0,0-4.671,4.72,25.459,25.459,0,0,0-3.212,4.367A36.731,36.731,0,0,1,284.92,84.563Z",
    transform: "translate(-5.553 -1.327)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5002",
    "data-name": "Path 5002",
    d: "M299.21,24.61a14.764,14.764,0,0,1-.372,2.546c-.294,1.635-.754,3.986-1.342,6.855-1.175,5.8-2.938,13.788-5.014,22.523s-4.26,16.647-5.934,22.356c-.832,2.84-1.537,5.131-2.056,6.7a13.8,13.8,0,0,1-.881,2.419,14.83,14.83,0,0,1,.558-2.507c.47-1.753,1.067-4.025,1.792-6.776,1.518-5.709,3.564-13.621,5.68-22.4L296.9,33.805c.656-2.771,1.195-5.063,1.616-6.855a14.687,14.687,0,0,1,.7-2.34Z",
    transform: "translate(-5.526 -0.511)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5003",
    "data-name": "Path 5003",
    d: "M286.023,69.3a29.613,29.613,0,0,0-13.768-23.267c-2.027-1.253-4.749-2.213-6.678-.813s-1.841,4.309-1.214,6.62A25.265,25.265,0,0,0,285.8,69.9",
    transform: "translate(-5.118 -0.924)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5004",
    "data-name": "Path 5004",
    d: "M273.24,53.15a4.485,4.485,0,0,1,1.136.744c.7.519,1.655,1.332,2.82,2.36a33.541,33.541,0,0,1,7.56,9.558,20.887,20.887,0,0,1,1.958,6.473,20.322,20.322,0,0,1-.1,5.513,19.962,19.962,0,0,1-.881,3.6c-.284.823-.47,1.263-.529,1.244s.47-1.87.823-4.9a21.875,21.875,0,0,0-.078-5.337,21.6,21.6,0,0,0-1.958-6.189,37.77,37.77,0,0,0-7.178-9.5,42.176,42.176,0,0,1-3.574-3.574Z",
    transform: "translate(-5.311 -1.103)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(83.506 74.413)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4741",
    "data-name": "Rectangle 4741",
    width: 249.759,
    height: 358.426,
    rx: 11.55,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4742",
    "data-name": "Rectangle 4742",
    width: 234.002,
    height: 299.328,
    transform: "translate(7.756 25.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5005",
    "data-name": "Path 5005",
    d: "M221.814,423.407a9.587,9.587,0,1,1-9.587-9.587,9.587,9.587,0,0,1,9.587,9.587Z",
    transform: "translate(-87.352 -82.999)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4743",
    "data-name": "Rectangle 4743",
    width: 75.226,
    height: 3.956,
    rx: 1.22,
    transform: "translate(87.261 10.321)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4744",
    "data-name": "Rectangle 4744",
    width: 186.421,
    height: 31.473,
    transform: "translate(33.961 48.963)",
    fill: "#189b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5006",
    "data-name": "Path 5006",
    d: "M177.76,137h1.41v9.89h-1.41Z",
    transform: "translate(-86.836 -77.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5007",
    "data-name": "Path 5007",
    d: "M190.74,137v9.89h-1.156l-5.934-7.374v7.374h-1.42V137H183.4l5.934,7.374V137Z",
    transform: "translate(-86.929 -77.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5008",
    "data-name": "Path 5008",
    d: "M193,145.811l.519-1.107a5.121,5.121,0,0,0,3.3,1.107c1.714,0,2.448-.666,2.448-1.528,0-2.419-5.993-.891-5.993-4.563,0-1.528,1.185-2.83,3.78-2.83a5.778,5.778,0,0,1,3.183.881l-.46,1.126a5.141,5.141,0,0,0-2.722-.8c-1.675,0-2.4.705-2.4,1.567,0,2.419,5.993.911,5.993,4.544,0,1.508-1.214,2.81-3.829,2.81A5.876,5.876,0,0,1,193,145.811Z",
    transform: "translate(-87.152 -77.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5009",
    "data-name": "Path 5009",
    d: "M202.83,142.66V137h1.42v5.572c0,2.184.979,3.173,2.781,3.173s2.8-.979,2.8-3.173V137H211.2v5.621c0,2.869-1.577,4.387-4.191,4.387S202.83,145.529,202.83,142.66Z",
    transform: "translate(-87.356 -77.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5010",
    "data-name": "Path 5010",
    d: "M220.95,146.93l-2.135-3.036H215.75V146.9h-1.41V137H218.2c2.566,0,4.123,1.3,4.123,3.447a3.124,3.124,0,0,1-2.174,3.124l2.35,3.32Zm0-6.444c0-1.41-.979-2.223-2.761-2.223h-2.4v4.456h2.4c1.772,0,2.722-.823,2.722-2.233Z",
    transform: "translate(-87.595 -77.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5011",
    "data-name": "Path 5011",
    d: "M231.1,144.463h-5.259l-1.087,2.468H223.3l4.485-9.89h1.4l4.495,9.89h-1.488Zm-.5-1.136-2.135-4.9-2.135,4.9Z",
    transform: "translate(-87.781 -77.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5012",
    "data-name": "Path 5012",
    d: "M243.91,137v9.89h-1.165l-5.934-7.374v7.374H235.4V137h1.156l5.934,7.374V137Z",
    transform: "translate(-88.032 -77.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5013",
    "data-name": "Path 5013",
    d: "M246.3,141.983a5,5,0,0,1,5.239-5.063,4.9,4.9,0,0,1,3.76,1.547l-.921.891a3.643,3.643,0,0,0-2.781-1.175,3.8,3.8,0,1,0,0,7.6,3.682,3.682,0,0,0,2.781-1.185l.921.891a4.9,4.9,0,0,1-3.77,1.557,5,5,0,0,1-5.229-5.063Z",
    transform: "translate(-88.258 -77.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5014",
    "data-name": "Path 5014",
    d: "M264.738,145.706v1.224H257.55V137h6.992v1.224H258.97v3.045h4.965v1.195H258.97v3.2Z",
    transform: "translate(-88.492 -77.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5015",
    "data-name": "Path 5015",
    d: "M310.57,200.258v-8.666l.069.069c-23.179.108-99.972.186-190.954.186h0l.255-.255v8.666l-.255-.255,135.284.108,40.747.078h.1l-40.7.069-135.47.108h-.255V191.19h.264c91,0,167.8.069,190.955.176h.069V199.6A2.2,2.2,0,0,1,310.57,200.258Z",
    transform: "translate(-85.625 -78.38)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5016",
    "data-name": "Path 5016",
    d: "M154.206,179.565c0,.147-8.392.264-18.743.264s-18.743-.118-18.743-.264,8.392-.255,18.743-.255S154.206,179.427,154.206,179.565Z",
    transform: "translate(-85.57 -78.133)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5017",
    "data-name": "Path 5017",
    d: "M307.718,335.7v-2.125c0-1.44,0-3.594-.049-6.551l.078.069c-23.179.108-99.972.186-190.955.186h0l.2-.284v8.676l-.255-.255,135.284.1,40.747.078h.088l-40.688.078-135.47.108h-.255V326.59h.264c91,0,167.8.078,190.955.186h.069v8.382C307.727,335.521,307.718,335.7,307.718,335.7Z",
    transform: "translate(-85.564 -81.189)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5018",
    "data-name": "Path 5018",
    d: "M155.956,318.125c0,.137-8.392.255-18.743.255s-18.753-.117-18.753-.255,8.392-.255,18.753-.255S155.956,318,155.956,318.125Z",
    transform: "translate(-85.606 -81.008)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5019",
    "data-name": "Path 5019",
    d: "M307.719,234.118v-2.135c0-1.43,0-3.584-.049-6.541l.078.069c-23.179.108-99.972.186-190.954.186h0l.255-.255v8.676l-.255-.255,135.284.1,40.747.078h.088l-40.688.078-135.47.108H116.5V225.04h.264c91,0,167.8.078,190.954.186h.069v8.236A3.217,3.217,0,0,1,307.719,234.118Z",
    transform: "translate(-85.565 -79.082)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5020",
    "data-name": "Path 5020",
    d: "M154.206,216.535c0,.147-8.392.264-18.743.264s-18.743-.118-18.743-.264,8.392-.255,18.743-.255S154.206,216.4,154.206,216.535Z",
    transform: "translate(-85.57 -78.901)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5021",
    "data-name": "Path 5021",
    d: "M197.956,267.968v-2.252c0-1.479,0-3.633-.059-6.424l.108.117c-14.111.078-45.193.147-81.21.147h0l.255-.264h0v8.657l-.255-.255,57.639.108,17.245.078h.127l-17.186.078-57.776.108h-.255v-8.911h0l.255-.255h0c36.017,0,67.1.069,81.21.147h.108v.1c0,2.82,0,4.994-.059,6.492v1.645A1.682,1.682,0,0,1,197.956,267.968Z",
    transform: "translate(-85.567 -79.785)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5022",
    "data-name": "Path 5022",
    d: "M154.206,250.395c0,.137-8.392.255-18.743.255s-18.743-.117-18.743-.255,8.392-.255,18.743-.255S154.206,250.258,154.206,250.395Z",
    transform: "translate(-85.57 -79.603)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5023",
    "data-name": "Path 5023",
    d: "M130.259,300.161a3.632,3.632,0,0,1-.049-.646c0-.47,0-1.058-.049-1.763,0-1.577-.069-3.7-.108-6.257l.206.2-13.524.059.255-.255h0v8.637l-.235-.235c3.917,0,7.266.078,9.665.117l2.81.069a3.734,3.734,0,0,1,1.048.049,5.479,5.479,0,0,1-.979.059l-2.752.069c-2.38,0-5.8.1-9.793.108h-.235v-8.882h0l.255-.255,13.523.049h.2v.206c0,2.693-.069,4.9-.108,6.385v1.714A2.713,2.713,0,0,1,130.259,300.161Z",
    transform: "translate(-85.566 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5024",
    "data-name": "Path 5024",
    d: "M148.481,300.161a4.522,4.522,0,0,1,0-.646q0-.705,0-1.763c0-1.577-.069-3.7-.108-6.257l.2.2-13.514.059.255-.255h0v8.637l-.235-.235c3.917,0,7.266.078,9.665.117l2.81.069a3.836,3.836,0,0,1,1.038.049,5.414,5.414,0,0,1-.979.059l-2.762.069c-2.38,0-5.787.1-9.793.108h-.235v-8.882h0l.255-.255,13.514.049h.118v.206c0,2.693-.069,4.9-.108,6.385,0,.685,0,1.253-.049,1.714a2.184,2.184,0,0,1-.069.578Z",
    transform: "translate(-85.945 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5025",
    "data-name": "Path 5025",
    d: "M166.708,300.161a5.345,5.345,0,0,1-.049-.646v-1.763c0-1.577-.059-3.7-.108-6.257l.206.2-13.514.059.255-.255h0v8.637l-.235-.235c3.917,0,7.276.078,9.665.117l2.81.069a3.938,3.938,0,0,1,1.048.049,5.412,5.412,0,0,1-.979.059l-2.762.069c-2.38,0-5.787.1-9.793.108H153v-8.882h0c-.225.225.313-.313.264-.255l13.514.049h.206v.206c0,2.693-.069,4.9-.108,6.385v1.714A3.008,3.008,0,0,1,166.708,300.161Z",
    transform: "translate(-86.321 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5026",
    "data-name": "Path 5026",
    d: "M184.94,300.161a3.633,3.633,0,0,1,0-.646c0-.47,0-1.058-.049-1.763,0-1.577-.059-3.7-.108-6.257l.206.2-13.523.059c0,.059.48-.48.255-.255h0v8.637l-.235-.235c3.917,0,7.276.078,9.665.117l2.81.069a3.733,3.733,0,0,1,1.048.049,5.479,5.479,0,0,1-.979.059l-2.752.069c-2.38,0-5.8.1-9.793.108h-.235v-8.882h0l.255-.255,13.524.049h.2v.206c0,2.693-.069,4.9-.108,6.385v1.714a2.712,2.712,0,0,1-.176.578Z",
    transform: "translate(-86.701 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5027",
    "data-name": "Path 5027",
    d: "M203.161,300.161a4.517,4.517,0,0,1,0-.646q0-.705,0-1.763c0-1.577-.069-3.7-.108-6.257l.2.2-13.514.059.255-.255h0v8.637l-.235-.235c3.917,0,7.266.078,9.665.117l2.81.069a3.584,3.584,0,0,1,1.038.049,5.279,5.279,0,0,1-.979.059l-2.761.069c-2.38,0-5.787.1-9.793.108H189.5v-8.882h0l.255-.255,13.514.049h.206v.206c0,2.693-.069,4.9-.108,6.385,0,.685,0,1.253-.049,1.714a2.185,2.185,0,0,1-.157.578Z",
    transform: "translate(-87.08 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5028",
    "data-name": "Path 5028",
    d: "M221.39,300.161a4.526,4.526,0,0,1,0-.646q0-.705-.059-1.763c0-1.577-.059-3.7-.1-6.257l.2.2-13.514.059.255-.255h0v8.637l-.235-.235c3.917,0,7.266.078,9.655.118l2.81.068a3.935,3.935,0,0,1,1.048.049,5.406,5.406,0,0,1-.979.059l-2.762.069c-2.38,0-5.787.1-9.793.108h-.235v-8.882h0l.255-.255,13.514.049h.206v.206c0,2.693-.069,4.9-.108,6.385,0,.686,0,1.253-.049,1.714a2.184,2.184,0,0,1-.108.578Z",
    transform: "translate(-87.457 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5029",
    "data-name": "Path 5029",
    d: "M239.62,300.161a3.629,3.629,0,0,1,0-.646c0-.47,0-1.058-.049-1.763,0-1.577-.059-3.7-.108-6.257l.206.2-13.523.059c0,.059.49-.48.255-.255h0v8.637l-.235-.235c3.917,0,7.276.078,9.665.117l2.81.069a3.938,3.938,0,0,1,1.048.049,5.479,5.479,0,0,1-.979.059l-2.752.069c-2.38,0-5.8.1-9.793.108h-.235v-8.882h0l.255-.255,13.523.049h.206v.206c0,2.693-.069,4.9-.1,6.385a14.622,14.622,0,0,1-.059,1.714A2.714,2.714,0,0,1,239.62,300.161Z",
    transform: "translate(-87.836 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5030",
    "data-name": "Path 5030",
    d: "M257.841,300.161v-2.409c0-1.577-.069-3.7-.108-6.257l.2.2-13.514.059.255-.255h0v8.637l-.235-.235c3.917,0,7.266.078,9.665.117l2.81.069a3.583,3.583,0,0,1,1.038.049,5.279,5.279,0,0,1-.979.059l-2.761.069c-2.37,0-5.787.1-9.793.108h-.235v-8.882h0l.255-.255,13.514.049h.206v.206c0,2.693-.069,4.9-.108,6.385,0,.685,0,1.253-.049,1.714A2.185,2.185,0,0,1,257.841,300.161Z",
    transform: "translate(-88.214 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5031",
    "data-name": "Path 5031",
    d: "M276.07,300.161a4.533,4.533,0,0,1,0-.646c0-.47,0-1.058-.059-1.763,0-1.577-.059-3.7-.1-6.257l.2.2-13.514.059.255-.255h0v8.637l-.235-.235c3.917,0,7.266.078,9.655.117l2.81.069a3.938,3.938,0,0,1,1.048.049,5.415,5.415,0,0,1-.979.059l-2.761.069c-2.38,0-5.787.1-9.793.108h-.235v-8.882h0l.255-.255,13.514.049h.206v.206c0,2.693-.069,4.9-.108,6.385v1.714A2.182,2.182,0,0,1,276.07,300.161Z",
    transform: "translate(-88.591 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5032",
    "data-name": "Path 5032",
    d: "M294.3,300.161a3.635,3.635,0,0,1,0-.646c0-.47,0-1.058-.049-1.763,0-1.577-.059-3.7-.108-6.257l.206.2-13.523.059c0,.059.49-.48.255-.255h0v8.637l-.235-.235c3.917,0,7.276.078,9.665.117l2.81.069a3.683,3.683,0,0,1,1.048.049,5.479,5.479,0,0,1-.979.059l-2.752.069c-2.38,0-5.8.1-9.793.108h-.235v-8.882h0l.255-.255,13.523.049h.206v.206c0,2.693-.069,4.9-.1,6.385a14.633,14.633,0,0,1-.059,1.714,2.709,2.709,0,0,1-.137.578Z",
    transform: "translate(-88.97 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5033",
    "data-name": "Path 5033",
    d: "M312.53,300.161a3.636,3.636,0,0,1-.049-.646v-1.763c0-1.577-.069-3.7-.108-6.257l.206.2-13.523.059.255-.255h0v8.637l-.235-.235c3.917,0,7.266.078,9.665.117l2.81.069a3.734,3.734,0,0,1,1.048.049,5.619,5.619,0,0,1-.979.059l-2.752.069c-2.38,0-5.8.1-9.793.108h-.235v-8.882h0l.255-.255,13.524.049h.2v.206c0,2.693-.069,4.9-.108,6.385,0,.685,0,1.253-.049,1.714a2.712,2.712,0,0,1-.127.578Z",
    transform: "translate(-89.348 -80.455)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5034",
    "data-name": "Path 5034",
    d: "M155.956,282.585c0,.147-8.392.255-18.743.255s-18.753-.108-18.753-.255,8.392-.255,18.753-.255S155.956,282.448,155.956,282.585Z",
    transform: "translate(-85.606 -80.271)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5035",
    "data-name": "Path 5035",
    d: "M308.656,267.968v-2.252c0-1.479,0-3.633-.069-6.424l.108.117c-14.1.078-45.183.147-81.21.147h0l.255-.264h0v8.657l-.255-.255,57.629.108,17.254.078h6.326a2.711,2.711,0,0,1-.392,0h-5.817l-17.186.078-57.776.108h-.255v-8.911h0l.255-.255h0c36.027,0,67.108.069,81.21.147h.117v.1c0,2.82,0,4.994-.059,6.492v1.645A1.781,1.781,0,0,1,308.656,267.968Z",
    transform: "translate(-87.863 -79.785)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5036",
    "data-name": "Path 5036",
    d: "M266.656,250.395c0,.137-8.392.255-18.743.255s-18.743-.117-18.743-.255,8.392-.255,18.743-.255S266.656,250.258,266.656,250.395Z",
    transform: "translate(-87.903 -79.603)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5037",
    "data-name": "Path 5037",
    d: "M247.522,381.474H175.057a12.407,12.407,0,0,1-12.407-12.407h0a12.407,12.407,0,0,1,12.407-12.407h72.465a12.407,12.407,0,0,1,12.417,12.4h0a12.407,12.407,0,0,1-12.417,12.417Z",
    transform: "translate(-86.523 -81.813)",
    fill: "#189b50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4745",
    "data-name": "Rectangle 4745",
    width: 2.448,
    height: 10.968,
    transform: "translate(62.741 59.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4746",
    "data-name": "Rectangle 4746",
    width: 2.448,
    height: 10.968,
    transform: "translate(58.481 65.874) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5038",
    "data-name": "Path 5038",
    d: "M159.151,141.806v-.9a1.4,1.4,0,0,0-.059-.382,7.041,7.041,0,0,0-.2-.979,8.931,8.931,0,0,0-.979-2.419,9.186,9.186,0,0,0-2.311-2.575,9.088,9.088,0,0,0-8.578-1.293,10.6,10.6,0,0,0-1.185.519,10.151,10.151,0,0,0-1.107.715,9.672,9.672,0,0,0-1.028.872,10.085,10.085,0,0,0-.881,1.058,8.989,8.989,0,0,0-1.3,2.487,9.117,9.117,0,0,0,0,5.719,8.705,8.705,0,0,0,1.293,2.487,10.252,10.252,0,0,0,.891,1.048,8.736,8.736,0,0,0,1.028.881,10.148,10.148,0,0,0,1.107.715,10.6,10.6,0,0,0,1.185.519,9.078,9.078,0,0,0,10.889-3.868,8.931,8.931,0,0,0,.979-2.419,7.036,7.036,0,0,0,.2-.979,1.2,1.2,0,0,1,.059-.382v.157a.955.955,0,0,1-.059.392,5.872,5.872,0,0,1-.176.979,8.471,8.471,0,0,1-.979,2.458,9.206,9.206,0,0,1-11.046,3.976,11.1,11.1,0,0,1-1.214-.529,9.969,9.969,0,0,1-1.126-.725,10.076,10.076,0,0,1-1.048-.891,9.516,9.516,0,0,1-.911-1.067,9.25,9.25,0,0,1,0-10.968,9.521,9.521,0,0,1,.911-1.067,9.007,9.007,0,0,1,1.048-.891,9.277,9.277,0,0,1,1.136-.725,10.2,10.2,0,0,1,1.2-.529,9.215,9.215,0,0,1,4.847-.382,9.048,9.048,0,0,1,3.868,1.733,9.264,9.264,0,0,1,2.331,2.624,8.471,8.471,0,0,1,.979,2.458,5.873,5.873,0,0,1,.176.979.889.889,0,0,0,.059.392v.754Z",
    transform: "translate(-86.069 -77.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5039",
    "data-name": "Path 5039",
    d: "M202.33,371.33h-3.378l-.588,1.518h-1.7l3.192-7.178H201.5l3.212,7.178h-1.743Zm-.529-1.263-1.136-2.742-1.136,2.742Z",
    transform: "translate(-87.228 -82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5040",
    "data-name": "Path 5040",
    d: "M205.07,369.28a3.917,3.917,0,0,1,6.855-2.438l-1.058.979a2.341,2.341,0,0,0-1.812-.842,2.3,2.3,0,1,0,1.812,3.741l1.058.979a3.917,3.917,0,0,1-6.855-2.429Z",
    transform: "translate(-87.403 -81.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5041",
    "data-name": "Path 5041",
    d: "M212.59,369.28a3.917,3.917,0,0,1,6.855-2.438l-1.067.979a2.366,2.366,0,1,0-1.8,3.751,2.272,2.272,0,0,0,1.8-.852l1.067.979a3.917,3.917,0,0,1-6.855-2.429Z",
    transform: "translate(-87.559 -81.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5042",
    "data-name": "Path 5042",
    d: "M226.272,371.536v1.312H220.72V365.67h5.415V367h-3.77v1.567h3.329v1.342h-3.329v1.665Z",
    transform: "translate(-87.728 -82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5043",
    "data-name": "Path 5043",
    d: "M233.958,368.294c0,1.606-1.195,2.6-3.114,2.6h-1.449v1.958H227.74V365.67h3.1C232.764,365.69,233.958,366.688,233.958,368.294Zm-1.675,0c0-.783-.519-1.244-1.528-1.244h-1.361v2.487h1.361C231.765,369.538,232.284,369.078,232.284,368.294Z",
    transform: "translate(-87.873 -82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5044",
    "data-name": "Path 5044",
    d: "M236.561,367.051H234.27V365.69h6.248v1.361h-2.291v5.8h-1.665Z",
    transform: "translate(-88.009 -82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5045",
    "data-name": "Path 5045",
    d: "M179.91,369.423l1.224-1.234,2.38,2.115,4.671-4.495,1.146,1.234-5.993,5.641Z",
    transform: "translate(-86.881 -82.003)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(5.626 431.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5046",
    "data-name": "Path 5046",
    d: "M432.942,441.365c0,.137-95.722.255-213.771.255S5.38,441.5,5.38,441.365s95.7-.255,213.791-.255S432.942,441.228,432.942,441.365Z",
    transform: "translate(-5.38 -441.11)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(324.64 111.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5047",
    "data-name": "Path 5047",
    d: "M399.654,416.061l-.979,16.334s16.265,6.512,16.373,9.548l-31.738-.813.519-25.51Z",
    transform: "translate(-332.235 -120.192)",
    fill: "#189b50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(55.642 310.577)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5048",
    "data-name": "Path 5048",
    d: "M388.92,431.09a1.3,1.3,0,0,0-.93,1.459,1.244,1.244,0,0,0,1.43.979,1.361,1.361,0,0,0,.979-1.547,1.3,1.3,0,0,0-1.606-.813",
    transform: "translate(-387.973 -431.09)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(51.007 318.372)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5049",
    "data-name": "Path 5049",
    d: "M383.24,441.616l.147-2.566,30.357,1.733s1.4.656,1.214,1.645Z",
    transform: "translate(-383.24 -439.05)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5050",
    "data-name": "Path 5050",
    d: "M399.4,432.6c0,.157-.783.206-1.557.686s-1.2,1.126-1.342,1.058.108-.979,1.058-1.518S399.437,432.46,399.4,432.6Z",
    transform: "translate(-332.507 -120.541)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5051",
    "data-name": "Path 5051",
    d: "M402.774,434.1c0,.147-.646.392-1.185,1.038s-.715,1.332-.872,1.322-.225-.891.46-1.675A1.675,1.675,0,0,1,402.774,434.1Z",
    transform: "translate(-332.594 -120.574)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5052",
    "data-name": "Path 5052",
    d: "M404.646,438.155c-.137,0-.333-.744.088-1.586s1.146-1.156,1.214-.979-.4.578-.734,1.273S404.8,438.145,404.646,438.155Z",
    transform: "translate(-332.674 -120.605)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5053",
    "data-name": "Path 5053",
    d: "M399.2,428.767c-.069.137-.774-.1-1.645-.059s-1.577.294-1.645.157.588-.666,1.626-.7S399.279,428.64,399.2,428.767Z",
    transform: "translate(-332.496 -120.452)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(51.399 298.111)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5054",
    "data-name": "Path 5054",
    d: "M399.416,419.359l-.176,2.908-15.6-.539.059-3.369Z",
    transform: "translate(-383.64 -418.36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5055",
    "data-name": "Path 5055",
    d: "M399.319,425.354a3.173,3.173,0,0,1-1.6-.049,7.255,7.255,0,0,1-1.645-.558,6.38,6.38,0,0,1-.9-.509,1.958,1.958,0,0,1-.47-.382.686.686,0,0,1,0-.832.862.862,0,0,1,.685-.333,2.113,2.113,0,0,1,.6.1,6.767,6.767,0,0,1,.979.362,5.877,5.877,0,0,1,1.44.979c.715.705.979,1.293.9,1.322s-.421-.45-1.155-.979a5.818,5.818,0,0,0-2.3-1.146c-.333-.1-.617-.108-.705,0s0,.078,0,.186a1.813,1.813,0,0,0,.343.284,9.334,9.334,0,0,0,.832.5,8.813,8.813,0,0,0,1.518.627A10.063,10.063,0,0,1,399.319,425.354Z",
    transform: "translate(-332.468 -120.338)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5056",
    "data-name": "Path 5056",
    d: "M399.192,425.523a2.614,2.614,0,0,1-.372-1.547,5.024,5.024,0,0,1,.255-1.733,5.561,5.561,0,0,1,.431-.979,1.312,1.312,0,0,1,1.038-.774.754.754,0,0,1,.656.46,2.458,2.458,0,0,1,.147.588,3.514,3.514,0,0,1,0,1.067,3.623,3.623,0,0,1-.725,1.626c-.636.8-1.293.979-1.3.921a6.39,6.39,0,0,0,.979-1.136,3.918,3.918,0,0,0,.539-1.488,3.232,3.232,0,0,0,0-.921c0-.333-.157-.607-.284-.578a1.154,1.154,0,0,0-.568.509,4.583,4.583,0,0,0-.421.852,5.463,5.463,0,0,0-.343,1.577C399.133,424.906,399.28,425.5,399.192,425.523Z",
    transform: "translate(-332.556 -120.293)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5057",
    "data-name": "Path 5057",
    d: "M406.145,314.46,380.9,322.568c.3.225,4.691,28.594,4.691,28.594l-3.613,75.275,20.026.245,8.96-78.967Z",
    transform: "translate(-332.185 -118.093)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5058",
    "data-name": "Path 5058",
    d: "M370.374,416l-.509,16.363s16.451,6,16.647,9.038l-31.757.157L354.51,416Z",
    transform: "translate(-331.637 -120.2)",
    fill: "#189b50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(27.491 310.811)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5059",
    "data-name": "Path 5059",
    d: "M360.131,431.359a1.293,1.293,0,0,0-.881,1.479,1.244,1.244,0,0,0,1.459.9,1.371,1.371,0,0,0,.93-1.577,1.293,1.293,0,0,0-1.626-.764",
    transform: "translate(-359.226 -431.329)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(23.128 318.793)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5060",
    "data-name": "Path 5060",
    d: "M354.77,442.055l.078-2.575,30.416.813s1.42.607,1.263,1.606Z",
    transform: "translate(-354.77 -439.48)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5061",
    "data-name": "Path 5061",
    d: "M370.649,432.547c0,.157-.774.225-1.537.725s-1.165,1.165-1.3,1.1.078-.979.979-1.547S370.688,432.4,370.649,432.547Z",
    transform: "translate(-331.912 -120.54)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5062",
    "data-name": "Path 5062",
    d: "M374.075,433.939c0,.147-.637.411-1.156,1.077s-.676,1.351-.832,1.342-.255-.881.411-1.684S374.075,433.792,374.075,433.939Z",
    transform: "translate(-331.999 -120.571)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5063",
    "data-name": "Path 5063",
    d: "M376.066,437.943c-.137,0-.362-.744,0-1.6s1.116-1.185,1.185-1.058-.382.588-.7,1.283S376.223,437.943,376.066,437.943Z",
    transform: "translate(-332.08 -120.599)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5064",
    "data-name": "Path 5064",
    d: "M370.34,428.718c-.069.137-.774-.069-1.655,0s-1.557.343-1.635.215.568-.7,1.606-.754S370.418,428.591,370.34,428.718Z",
    transform: "translate(-331.897 -120.452)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(22.893 298.533)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5065",
    "data-name": "Path 5065",
    d: "M370.267,419.309l-.088,2.918-15.609-.069-.039-3.369Z",
    transform: "translate(-354.53 -418.79)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5066",
    "data-name": "Path 5066",
    d: "M370.348,425.306a3.123,3.123,0,0,1-1.586,0,7.361,7.361,0,0,1-1.665-.509,6.859,6.859,0,0,1-.921-.48,1.724,1.724,0,0,1-.48-.372.666.666,0,0,1-.078-.823.872.872,0,0,1,.676-.362,2.075,2.075,0,0,1,.6.088,5.2,5.2,0,0,1,.979.333,5.768,5.768,0,0,1,1.469.979,3.761,3.761,0,0,1,.979,1.293c0,.029-.431-.431-1.185-.979a6.372,6.372,0,0,0-1.42-.783,5.307,5.307,0,0,0-.921-.284c-.333-.088-.617-.088-.705.069s0,.078,0,.176a1.369,1.369,0,0,0,.352.264,8.257,8.257,0,0,0,2.38,1.058,10.422,10.422,0,0,1,1.528.333Z",
    transform: "translate(-331.865 -120.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5067",
    "data-name": "Path 5067",
    d: "M370.241,425.473a2.534,2.534,0,0,1-.431-1.528,5.2,5.2,0,0,1,.206-1.743,5.8,5.8,0,0,1,.4-.979,1.312,1.312,0,0,1,.979-.8.715.715,0,0,1,.666.431,1.851,1.851,0,0,1,.166.588,3.262,3.262,0,0,1,0,1.067,3.722,3.722,0,0,1-.666,1.645,2.385,2.385,0,0,1-1.283.979,5.313,5.313,0,0,0,.979-1.175,3.663,3.663,0,0,0,.5-1.5,3.261,3.261,0,0,0,0-.921c0-.333-.176-.607-.3-.568a1.167,1.167,0,0,0-.548.519,4.8,4.8,0,0,0-.392.862,5.76,5.76,0,0,0-.3,1.6C370.153,424.9,370.319,425.453,370.241,425.473Z",
    transform: "translate(-331.954 -120.291)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5068",
    "data-name": "Path 5068",
    d: "M350,318.57c0,5.689,2.252,111.38,2.252,111.38l19.007-1.7,3.917-64.934,2.047-5.67,2.389-34.989Z",
    transform: "translate(-331.544 -118.178)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5069",
    "data-name": "Path 5069",
    d: "M391.026,178.61c.255.343,15.1,23.9,15.1,23.9l16.7-17.47,8.539,12.329s-17.852,25.2-20.476,26.107-11.066-.519-11.066-.519L388,207.39Z",
    transform: "translate(-332.332 -115.275)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5070",
    "data-name": "Path 5070",
    d: "M406.633,208.455a6.748,6.748,0,0,1-.313-2.713,8.814,8.814,0,0,1,.186-2.722,6.639,6.639,0,0,1,.323,2.713,8.215,8.215,0,0,1-.2,2.722Z",
    transform: "translate(-332.711 -115.781)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5071",
    "data-name": "Path 5071",
    d: "M352.179,160.68l-2.566,6.326s-13.171,11.115-14.366,12.828,9.4,57.12,9.4,57.12-.676,81.405,0,81.405,9.793,2.938,28.4,1.537,22.063-3.2,22.063-3.2l-5.817-72-8.9-48.444-15.267-19.663Z",
    transform: "translate(-331.236 -114.903)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5072",
    "data-name": "Path 5072",
    d: "M382.556,188.1s-1.958-9.391-1.792-9.685-4.387-11.389-4.387-11.389l-1.518-5.1L354.1,158.42l-.979,3.134,27.674,34.969,2.84,15.012,2.938-4.093Z",
    transform: "translate(-331.608 -114.856)",
    fill: "#189b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5073",
    "data-name": "Path 5073",
    d: "M401.552,258.925l-4.5-54.172L393.356,183.6a22.973,22.973,0,0,0-3.32-8.471l-10.772-6.238a47.928,47.928,0,0,1-3.085-4.123l5.1,13.034,1.792,10.409L384.19,212.1h0l5.876,32.071,5.758,70.506,12.5-2.4Z",
    transform: "translate(-332.087 -114.987)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5074",
    "data-name": "Path 5074",
    d: "M384.591,195.813l2.419-17.773-7.785-9.127-3.085-4.123,4.789,13.758Z",
    transform: "translate(-332.086 -114.988)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5075",
    "data-name": "Path 5075",
    d: "M372.126,229.783l18.811-26.763,32.746,9.9-24.775,32.041-30.739-10Z",
    transform: "translate(-331.92 -115.781)",
    fill: "#aea8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5076",
    "data-name": "Path 5076",
    d: "M415.056,211.853a.813.813,0,1,1-.813-.813A.813.813,0,0,1,415.056,211.853Z",
    transform: "translate(-332.859 -115.947)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5077",
    "data-name": "Path 5077",
    d: "M401.7,208.123a.813.813,0,1,1-.813-.8.813.813,0,0,1,.813.8Z",
    transform: "translate(-332.582 -115.87)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5078",
    "data-name": "Path 5078",
    d: "M386.05,185.45c-.049,0,.352,1.743.911,3.917a35.958,35.958,0,0,0,1.1,3.819s-.352-1.743-.911-3.917a36.828,36.828,0,0,0-1.1-3.819Z",
    transform: "translate(-332.291 -115.417)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5079",
    "data-name": "Path 5079",
    d: "M392.286,197.6a4.122,4.122,0,0,1-.294,2.252A2.732,2.732,0,0,1,390.3,201.4a3.085,3.085,0,0,1-2.938-.636,7.766,7.766,0,0,1-1.87-5.65,3.418,3.418,0,0,1,2.145-2.938,3.085,3.085,0,0,1,3.535,1.518",
    transform: "translate(-332.279 -115.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5080",
    "data-name": "Path 5080",
    d: "M391.117,193.724a2.34,2.34,0,0,0-.5-.705,3.146,3.146,0,0,0-.8-.637,3,3,0,0,0-1.3-.372,3.693,3.693,0,0,0-.793.078,2.368,2.368,0,0,0-.8.333,3.418,3.418,0,0,0-1.214,1.449,4.446,4.446,0,0,0-.392,2.047,7.833,7.833,0,0,0,.392,2.194,6.072,6.072,0,0,0,1.753,2.938,2.82,2.82,0,0,0,1.439.6,3.447,3.447,0,0,0,1.43-.127h0a2.1,2.1,0,0,0,.911-.49,3.33,3.33,0,0,0,.607-.705,3.8,3.8,0,0,0,.49-1.41,3.5,3.5,0,0,0,0-.979,1.156,1.156,0,0,0,0-.245.32.32,0,0,0,0-.078,5.382,5.382,0,0,1-.049,1.263,3.77,3.77,0,0,1-.509,1.342,3.377,3.377,0,0,1-.587.666,1.89,1.89,0,0,1-.852.45h0a2.987,2.987,0,0,1-2.7-.47,6.091,6.091,0,0,1-1.675-2.81,5.7,5.7,0,0,1,0-4.1,3.163,3.163,0,0,1,1.136-1.391,2.262,2.262,0,0,1,.744-.323,2.566,2.566,0,0,1,.754-.078,2.762,2.762,0,0,1,1.263.323,3.791,3.791,0,0,1,.8.588,5.264,5.264,0,0,1,.46.656Z",
    transform: "translate(-332.276 -115.553)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5081",
    "data-name": "Path 5081",
    d: "M393.175,197.443a4.1,4.1,0,0,1-.294,2.252,2.771,2.771,0,0,1-1.694,1.557,3.085,3.085,0,0,1-2.987-.637,7.834,7.834,0,0,1-1.87-5.65,3.427,3.427,0,0,1,2.145-2.938,3.1,3.1,0,0,1,3.535,1.528",
    transform: "translate(-332.297 -115.551)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5082",
    "data-name": "Path 5082",
    d: "M392.007,193.574a2.3,2.3,0,0,0-.5-.715,3.371,3.371,0,0,0-.8-.627,2.938,2.938,0,0,0-1.3-.372,2.762,2.762,0,0,0-.793.078,2.469,2.469,0,0,0-.8.323,3.437,3.437,0,0,0-1.214,1.459,4.554,4.554,0,0,0-.4,2.047,8.236,8.236,0,0,0,.4,2.194,6.17,6.17,0,0,0,1.753,2.938,2.821,2.821,0,0,0,1.44.6,3.467,3.467,0,0,0,1.43-.127h0a2.066,2.066,0,0,0,.911-.5,3.366,3.366,0,0,0,.607-.705,3.917,3.917,0,0,0,.49-1.4,3.5,3.5,0,0,0,0-.979,1.054,1.054,0,0,0,0-.245.644.644,0,0,0,0-.088,5.407,5.407,0,0,1-.049,1.263,3.811,3.811,0,0,1-.509,1.351,3.142,3.142,0,0,1-.6.666,1.959,1.959,0,0,1-.852.45h0a3.016,3.016,0,0,1-2.7-.46,6.091,6.091,0,0,1-1.674-2.81,5.719,5.719,0,0,1,0-4.113,3.281,3.281,0,0,1,1.136-1.391,2.243,2.243,0,0,1,.744-.313,2.879,2.879,0,0,1,.754-.088,2.771,2.771,0,0,1,1.263.333,3.213,3.213,0,0,1,.8.588,5.527,5.527,0,0,1,.47.646Z",
    transform: "translate(-332.294 -115.549)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5083",
    "data-name": "Path 5083",
    d: "M390.56,193.557a1.959,1.959,0,0,1,2.252.617,3.32,3.32,0,0,1,.607,2.38,2.938,2.938,0,0,1-.323,1.224,1.694,1.694,0,0,1-.979.813,1.958,1.958,0,0,1-1.733-.5,3.515,3.515,0,0,1-1.244-2.654,1.655,1.655,0,0,1,.979-1.635",
    transform: "translate(-332.355 -115.582)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5084",
    "data-name": "Path 5084",
    d: "M390.118,193.8h-.147a1.1,1.1,0,0,0-.362.235,1.959,1.959,0,0,0-.5,1.469,3.516,3.516,0,0,0,.8,2.164,2.938,2.938,0,0,0,1.1.862,1.606,1.606,0,0,0,1.488,0,2.027,2.027,0,0,0,.881-1.2,4.221,4.221,0,0,0,.137-1.381,2.938,2.938,0,0,0-.93-2.105,2.066,2.066,0,0,0-1.479-.48,1.82,1.82,0,0,0-.421.108l-.127.078a2.745,2.745,0,0,1,.548-.108,2.027,2.027,0,0,1,1.391.509,2.791,2.791,0,0,1,.842,2.007,4.064,4.064,0,0,1-.147,1.312,1.861,1.861,0,0,1-.793,1.1,1.459,1.459,0,0,1-1.322,0,2.938,2.938,0,0,1-1.028-.793,3.418,3.418,0,0,1-.8-2.056,1.958,1.958,0,0,1,.421-1.42A1.9,1.9,0,0,1,390.118,193.8Z",
    transform: "translate(-332.355 -115.581)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5085",
    "data-name": "Path 5085",
    d: "M390.309,200.131a.592.592,0,0,1,.127-.313,1.312,1.312,0,0,1,.519-.558,3.192,3.192,0,0,1,.725-.323c.206-.069.323-.117.323-.147a.783.783,0,0,0-.353,0,2.193,2.193,0,0,0-.8.294,1.2,1.2,0,0,0-.539.676A.449.449,0,0,0,390.309,200.131Z",
    transform: "translate(-332.379 -115.693)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5086",
    "data-name": "Path 5086",
    d: "M388.29,193.616a.872.872,0,0,0,.294.206,1.959,1.959,0,0,0,.862.137,1.89,1.89,0,0,0,.823-.264c.186-.117.274-.235.255-.245a4.465,4.465,0,0,1-1.1.313,4.9,4.9,0,0,1-1.136-.147Z",
    transform: "translate(-332.338 -115.582)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5087",
    "data-name": "Path 5087",
    d: "M372.764,207.106c-.979.274-2.1-.45-3.065-.078a1.439,1.439,0,1,0,1.116,2.644c.979-.45,1.2-1.861,2.135-2.419",
    transform: "translate(-331.932 -115.862)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5088",
    "data-name": "Path 5088",
    d: "M364.357,210.107a5.319,5.319,0,0,0,.9-.372l-.166-.313a4.074,4.074,0,0,1-3.222.382,5.954,5.954,0,0,1-3.192-3.29v-.069c-.353-.705-5.19-15.139-6.081-17.891a4.9,4.9,0,0,1,2.34-6.179c.147-.078,3.388-1.763,6.727,2.34,3.5,4.3,9.606,12.789,10.165,13.827l.264.47c.774,1.312,2.4,4.064.979,6.4-1.577,2.6-3.555,2.438-3.633,2.429v.353c.088,0,2.272.215,3.986-2.6,1.528-2.526-.166-5.4-.979-6.776-.108-.176-.2-.323-.264-.45-.568-1.048-6.7-9.577-10.2-13.886s-7.129-2.448-7.168-2.429a5.347,5.347,0,0,0-2.517,6.6c.734,2.272,5.738,17.2,6.111,17.94v.069a6.257,6.257,0,0,0,3.4,3.476,4.064,4.064,0,0,0,2.556-.039Z",
    transform: "translate(-331.584 -115.338)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5089",
    "data-name": "Path 5089",
    d: "M353.318,191.449a6.571,6.571,0,0,1,.157-1.959,6.072,6.072,0,0,1,2.712-3.613,6.679,6.679,0,0,1,4.465-.832,7.578,7.578,0,0,1,1.841.588l-.108-.078a2.329,2.329,0,0,0-.343-.2,5.669,5.669,0,0,0-1.361-.441,6.61,6.61,0,0,0-4.593.793,6.042,6.042,0,0,0-1.88,1.8,5.875,5.875,0,0,0-.862,1.958,4.976,4.976,0,0,0-.117,1.43,2.255,2.255,0,0,0,.059.382C353.3,191.4,353.308,191.449,353.318,191.449Z",
    transform: "translate(-331.61 -115.403)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5090",
    "data-name": "Path 5090",
    d: "M349.92,167.006l16.236,20.114,14.542,9.127L352.486,160.68Z",
    transform: "translate(-331.542 -114.903)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5091",
    "data-name": "Path 5091",
    d: "M335.167,180.229s-3.408,5.366-3.917,10.85c-.215,2.154,5.131,42.421,5.738,44.233s7.7,6.336,9.793,7.246,27.928,9.509,38.495,9.362l2.262-19.928-27.155-4.534s-3.173-3.016-4.828-3.623l-2.262-22.19-3.329-17.813S340.474,177.977,335.167,180.229Z",
    transform: "translate(-331.154 -115.298)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5092",
    "data-name": "Path 5092",
    d: "M397.482,204.31c-.137,0-1.6-5.876-3.261-13.161s-2.938-13.24-2.771-13.269,1.606,5.876,3.271,13.161S397.619,204.281,397.482,204.31Z",
    transform: "translate(-332.403 -115.259)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5093",
    "data-name": "Path 5093",
    d: "M351.92,199.688a1.621,1.621,0,0,0,.088.421l.206,1.224c.176,1.107.431,2.713.754,4.769.646,4.172,1.567,10.2,2.722,17.725l-.108-.137a10.606,10.606,0,0,1,2.526,1.606c.8.627,1.586,1.312,2.37,2.037l-.1-.049,27.184,4.485h.225v.215c-.705,6.238-1.459,12.956-2.252,19.938v.225h-.225a69.849,69.849,0,0,1-14.943-2.331c-6.277-1.5-12.309-3.281-18.087-5.131-1.449-.48-2.879-.979-4.289-1.44a18.087,18.087,0,0,1-4-1.958c-1.253-.764-2.468-1.557-3.623-2.409a17.706,17.706,0,0,1-3.212-2.84,2.145,2.145,0,0,1-.46-.979c-.088-.353-.137-.7-.2-1.038-.108-.676-.215-1.361-.333-2.027-.2-1.342-.392-2.673-.588-3.976q-.548-3.917-1.058-7.619c-.666-4.9-1.263-9.5-1.782-13.71s-.979-7.971-1.3-11.31c-.078-.832-.176-1.635-.225-2.419a9.719,9.719,0,0,1,0-2.262,26.845,26.845,0,0,1,.921-3.829,30.04,30.04,0,0,1,2.105-5.014c.294-.548.539-.979.705-1.224a3.8,3.8,0,0,1,.274-.392l-.235.421c-.147.274-.382.685-.656,1.244a33.456,33.456,0,0,0-1.959,5.024,28.578,28.578,0,0,0-.872,3.809,9.287,9.287,0,0,0,0,2.2c.059.774.166,1.577.245,2.409.362,3.329.842,7.119,1.381,11.291s1.175,8.813,1.841,13.71c.352,2.458.705,4.994,1.077,7.609.206,1.3.4,2.634.607,3.976.108.666.215,1.342.333,2.017a3.941,3.941,0,0,0,.186.979,1.616,1.616,0,0,0,.382.852,17.627,17.627,0,0,0,3.124,2.742c1.146.832,2.35,1.626,3.594,2.38a17.882,17.882,0,0,0,3.917,1.959c1.4.5,2.83.979,4.27,1.43,5.778,1.841,11.8,3.623,18.057,5.121a70.789,70.789,0,0,0,14.826,2.321l-.255.225c.8-6.982,1.567-13.71,2.282-19.928l.2.264L360.4,227.714h-.059c-.764-.725-1.547-1.41-2.34-2.037a10.9,10.9,0,0,0-2.419-1.557h-.1v-.1c-1.1-7.53-1.958-13.572-2.575-17.744-.284-2.066-.509-3.672-.666-4.779-.069-.529-.117-.979-.157-1.244a3.332,3.332,0,0,1-.167-.568Z",
    transform: "translate(-331.152 -115.308)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5094",
    "data-name": "Path 5094",
    d: "M350.456,193.739a16.818,16.818,0,0,1-1.253-2.419,26.334,26.334,0,0,0-3.388-5.533,12.143,12.143,0,0,0-5.18-3.711,19.188,19.188,0,0,0-2.634-.568,1.841,1.841,0,0,1,.744-.078,7.521,7.521,0,0,1,1.959.3,11.516,11.516,0,0,1,5.464,3.721,22.69,22.69,0,0,1,3.329,5.719A13.243,13.243,0,0,1,350.456,193.739Z",
    transform: "translate(-331.295 -115.333)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5095",
    "data-name": "Path 5095",
    d: "M346.28,228.481a10.419,10.419,0,0,1,9.42-3.613A16.285,16.285,0,0,0,346.28,228.481Z",
    transform: "translate(-331.466 -116.232)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5096",
    "data-name": "Path 5096",
    d: "M349.43,231.635a10.086,10.086,0,0,1,6.747-6.855,25.667,25.667,0,0,0-3.917,2.938,26.143,26.143,0,0,0-2.83,3.917Z",
    transform: "translate(-331.532 -116.232)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5097",
    "data-name": "Path 5097",
    d: "M380.694,196.248a7.217,7.217,0,0,1-1.126-.607l-3.045-1.831-10.5-6.483h0l-4.9-6.032c-4.495-5.562-8.52-10.6-11.31-14.131l-.069-.078v-.1c.813-1.9,1.469-3.457,1.959-4.612.225-.49.4-.9.548-1.234s.206-.421.225-.411a1.655,1.655,0,0,1-.127.45l-.47,1.273-1.8,4.671v-.176c2.859,3.467,6.933,8.461,11.428,14.033l4.9,6.042-.059-.059,10.4,6.639,2.938,1.959A7.075,7.075,0,0,1,380.694,196.248Z",
    transform: "translate(-331.538 -114.904)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5098",
    "data-name": "Path 5098",
    d: "M383.621,200.112a5.876,5.876,0,0,1,.1-1.3c.117-.93.264-2.125.45-3.574.4-3.016.979-7.217,1.694-11.947v.157l-.979-1.792c-2.487-4.622-4.71-8.813-6.306-11.878-.744-1.469-1.371-2.683-1.851-3.623a8.815,8.815,0,0,1-.627-1.361,7.493,7.493,0,0,1,.8,1.263l1.959,3.555c1.665,3.006,3.917,7.178,6.434,11.751.323.617.656,1.224.979,1.8v.157c-.715,4.72-1.361,8.911-1.861,11.927-.245,1.43-.441,2.615-.6,3.535A7.643,7.643,0,0,1,383.621,200.112Z",
    transform: "translate(-332.085 -114.988)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5099",
    "data-name": "Path 5099",
    d: "M353.242,182.664l.832-.5-.832.5a50.99,50.99,0,0,1-3.662-6.855l-.166-.421c-.979-2.4-2.125-5.112-1.645-7.736v-.069a5.121,5.121,0,0,1,1.782-2.938l.274-.225h.8v1.547l.176.215-.186.157v.069h-.069a3.075,3.075,0,0,0-.872,1.606v.059c-.352,2.047.646,4.465,1.528,6.6l.176.421a48.954,48.954,0,0,0,3.525,6.541Z",
    transform: "translate(-331.495 -114.98)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5100",
    "data-name": "Path 5100",
    d: "M389.94,244a5.863,5.863,0,0,1,.127.734c.078.529.166,1.234.294,2.115.235,1.841.558,4.5.93,7.834.754,6.581,1.684,15.668,2.536,25.784s1.459,19.233,1.831,25.852c.186,3.31.313,5.993.382,7.834,0,.891.059,1.6.069,2.135a3.244,3.244,0,0,1,0,.754,5,5,0,0,1-.088-.744c0-.539-.1-1.244-.166-2.135-.137-1.9-.323-4.563-.548-7.834-.46-6.62-1.126-15.756-1.958-25.843s-1.723-19.193-2.38-25.794c-.323-3.251-.588-5.875-.774-7.834-.088-.881-.147-1.586-.2-2.125A3.557,3.557,0,0,1,389.94,244Z",
    transform: "translate(-332.372 -116.631)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5101",
    "data-name": "Path 5101",
    d: "M376.677,267.46a6.2,6.2,0,0,1-.666.636c-.45.382-1.107.93-1.959,1.577a57.482,57.482,0,0,1-6.8,4.671,36.5,36.5,0,0,1-4.083,2.017,24.645,24.645,0,0,1-3.545,1.136,16.04,16.04,0,0,1-2.478.421,2.7,2.7,0,0,1-.911,0c0-.088,1.283-.235,3.29-.793a29.018,29.018,0,0,0,3.457-1.234A39.49,39.49,0,0,0,367,273.874c2.771-1.6,5.121-3.3,6.855-4.514A26.43,26.43,0,0,1,376.677,267.46Z",
    transform: "translate(-331.673 -117.118)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5102",
    "data-name": "Path 5102",
    d: "M378.192,271.36a3.291,3.291,0,0,1-.519.793,22.459,22.459,0,0,1-1.694,1.959,28.3,28.3,0,0,1-6.855,5.121,27.8,27.8,0,0,1-8.059,2.81,20.133,20.133,0,0,1-2.575.3,3.918,3.918,0,0,1-.979,0c0-.088,1.332-.2,3.447-.656a30.9,30.9,0,0,0,14.689-7.834C377.281,272.359,378.123,271.3,378.192,271.36Z",
    transform: "translate(-331.699 -117.199)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5103",
    "data-name": "Path 5103",
    d: "M357.247,282.815a14.61,14.61,0,0,1-.548-5.415A14.611,14.611,0,0,1,357.247,282.815Z",
    transform: "translate(-331.681 -117.324)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5104",
    "data-name": "Path 5104",
    d: "M354.769,149.643a1.9,1.9,0,0,1-1.684-1.146,6.3,6.3,0,0,1-.558-2.184l-1.381-10.008a50.98,50.98,0,0,1-.7-8.539,18.351,18.351,0,0,1,2.517-7.834c1.508-2.938,7.619-8.02,17.764-5.151",
    transform: "translate(-331.553 -113.933)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5105",
    "data-name": "Path 5105",
    d: "M354.221,138.145c-.137-.059-5.415-1.5-5.151,3.858s5.6,3.986,5.6,3.829S354.221,138.145,354.221,138.145Z",
    transform: "translate(-331.524 -114.431)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5106",
    "data-name": "Path 5106",
    d: "M352.947,143.911a2.163,2.163,0,0,1-.245.157.979.979,0,0,1-.7.049,2.33,2.33,0,0,1-1.175-2.017,3.172,3.172,0,0,1,.2-1.351,1.087,1.087,0,0,1,.666-.754.48.48,0,0,1,.568.225c.078.147.049.255.078.264s.108-.1.059-.313a.587.587,0,0,0-.235-.323.705.705,0,0,0-.519-.117,1.312,1.312,0,0,0-.93.881,3.2,3.2,0,0,0-.255,1.518,2.428,2.428,0,0,0,1.479,2.242.979.979,0,0,0,.852-.186A.385.385,0,0,0,352.947,143.911Z",
    transform: "translate(-331.553 -114.468)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5107",
    "data-name": "Path 5107",
    d: "M381.858,147.647c0-3.78-.705-11.585-1.4-18.606a14.62,14.62,0,0,0-14.816-13.181h-.754c-8.157.627-12.172,7.9-11.32,16.03l1.146,25.931,19.438,10.664-.059-11.624S381.907,155.49,381.858,147.647Z",
    transform: "translate(-331.615 -113.973)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5108",
    "data-name": "Path 5108",
    d: "M374.321,157.664A18.214,18.214,0,0,1,364,155s2.468,5.69,10.282,4.838Z",
    transform: "translate(-331.834 -114.785)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5109",
    "data-name": "Path 5109",
    d: "M378.333,134.519a1.126,1.126,0,0,1-1.058,1.155,1.077,1.077,0,0,1-1.175-.979,1.126,1.126,0,0,1,1.058-1.156,1.068,1.068,0,0,1,1.175.979Z",
    transform: "translate(-332.085 -114.339)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5110",
    "data-name": "Path 5110",
    d: "M379.4,132.8c-.137.147-.979-.46-2.2-.441s-2.076.646-2.2.5.069-.333.45-.617a3.055,3.055,0,0,1,1.763-.578,2.938,2.938,0,0,1,1.753.529C379.337,132.463,379.464,132.727,379.4,132.8Z",
    transform: "translate(-332.061 -114.301)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5111",
    "data-name": "Path 5111",
    d: "M366.373,134.769a1.116,1.116,0,0,1-1.058,1.146,1.067,1.067,0,0,1-1.175-.979,1.126,1.126,0,0,1,1.058-1.146,1.077,1.077,0,0,1,1.175.979Z",
    transform: "translate(-331.837 -114.345)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5112",
    "data-name": "Path 5112",
    d: "M367.126,132.681c-.118.166-1.038-.353-2.233-.2s-1.959.862-2.145.734,0-.333.382-.666a3.075,3.075,0,0,1,1.694-.764,2.938,2.938,0,0,1,1.8.333C367.028,132.357,367.184,132.6,367.126,132.681Z",
    transform: "translate(-331.806 -114.303)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5113",
    "data-name": "Path 5113",
    d: "M371.9,142.528a7.834,7.834,0,0,1,1.959-.392c.313,0,.6-.1.646-.313a1.635,1.635,0,0,0-.215-.911l-.979-2.321a40.522,40.522,0,0,1-2.154-6.091,39.9,39.9,0,0,1,2.644,5.876c.313.813.627,1.6.911,2.34a1.753,1.753,0,0,1,.186,1.2.8.8,0,0,1-.5.46,2.223,2.223,0,0,1-.519.078A7.834,7.834,0,0,1,371.9,142.528Z",
    transform: "translate(-331.983 -114.318)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5114",
    "data-name": "Path 5114",
    d: "M368.316,143.66c.2,0,.215,1.293,1.351,2.2s2.526.734,2.546.921-.3.255-.9.284a3.252,3.252,0,0,1-2.115-.7,2.86,2.86,0,0,1-1.058-1.851C368.081,143.993,368.218,143.65,368.316,143.66Z",
    transform: "translate(-331.92 -114.55)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5115",
    "data-name": "Path 5115",
    d: "M367.173,127.372c-.108.323-1.312.2-2.732.392s-2.546.6-2.732.313.108-.45.558-.783a4.8,4.8,0,0,1,4.172-.529C366.958,126.99,367.222,127.215,367.173,127.372Z",
    transform: "translate(-331.785 -114.194)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5116",
    "data-name": "Path 5116",
    d: "M378.773,129.664c-.206.274-1.038,0-2.037,0s-1.841.225-2.047-.059c-.088-.137,0-.421.411-.685a2.938,2.938,0,0,1,3.29,0C378.743,129.252,378.91,129.526,378.773,129.664Z",
    transform: "translate(-332.055 -114.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5117",
    "data-name": "Path 5117",
    d: "M371.348,114.987c-2.771-1.087-5.582-.519-8.529-.078a13.386,13.386,0,0,0-6.277,2.5,12.035,12.035,0,0,0-4.612,9.4,34.714,34.714,0,0,0,1.155,10.576l.294-.069a4.985,4.985,0,0,0,0,2.732,1.753,1.753,0,0,0,2.164,1.175c.979-.431.979-1.792.921-2.869a77.576,77.576,0,0,1,0-10.88c.157-2.713,1.7-6.032,3.809-7.315,3.848-2.556,8.862-.47,10.566-.176,2.6-2.233,5.043-.48,6.639,1.459C376.812,118.5,374.119,116.074,371.348,114.987Z",
    transform: "translate(-331.583 -113.942)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5118",
    "data-name": "Path 5118",
    d: "M371.108,119.965c1.714,0,3.085-1.156,5-.842,1.156.2,2.311,2.076,3.32,4.426a3.4,3.4,0,0,0-.979-6.218,2.938,2.938,0,0,0,1.528.5,1.058,1.058,0,0,0,1.077-.979,1.43,1.43,0,0,0-.637-.979,8.373,8.373,0,0,0-11.751,1.351",
    transform: "translate(-331.931 -113.935)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5119",
    "data-name": "Path 5119",
    d: "M380,116.751c-.049.069-.558-.294-1.479-.588a5.738,5.738,0,0,0-6.581,2.282c-.548.8-.725,1.4-.8,1.381a2.713,2.713,0,0,1,.49-1.567,5.562,5.562,0,0,1,7.011-2.429C379.6,116.232,380.041,116.712,380,116.751Z",
    transform: "translate(-331.982 -113.963)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5120",
    "data-name": "Path 5120",
    d: "M379.64,122.706a5.947,5.947,0,0,0,0-1.831,3.8,3.8,0,0,0-.862-1.7,4.044,4.044,0,0,0-1.958-1.2,5.415,5.415,0,0,0-4.181.725c-.979.607-1.44,1.165-1.508,1.107a3.6,3.6,0,0,1,1.312-1.4,5.72,5.72,0,0,1,1.9-.911,5.092,5.092,0,0,1,2.6,0,4.329,4.329,0,0,1,2.223,1.381,3.966,3.966,0,0,1,.852,1.958A2.37,2.37,0,0,1,379.64,122.706Z",
    transform: "translate(-331.982 -114.003)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5121",
    "data-name": "Path 5121",
    d: "M351.322,135.676a2.085,2.085,0,0,1-.206-.725,10.927,10.927,0,0,1-.176-2.017,13.5,13.5,0,0,1,6.14-11.35,10.426,10.426,0,0,1,1.782-.979,1.958,1.958,0,0,1,.715-.225c0,.088-.979.49-2.291,1.479a14.366,14.366,0,0,0-5.983,11.066C351.214,134.618,351.41,135.676,351.322,135.676Z",
    transform: "translate(-331.563 -114.067)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5122",
    "data-name": "Path 5122",
    d: "M352.546,136.77a12.064,12.064,0,0,1,3.623-10.86,24.305,24.305,0,0,0-2.7,5.131,24.991,24.991,0,0,0-.92,5.729Z",
    transform: "translate(-331.593 -114.181)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5123",
    "data-name": "Path 5123",
    d: "M442.665,182.506c-.225-.6-1.351-.725-1.351-.725l.225-.343a1.655,1.655,0,0,0,.088-1.655l-.127-.245a2.752,2.752,0,0,0-1.312-.979s.832-1.126.627-1.684a2.683,2.683,0,0,0-2.556-1.508,38.6,38.6,0,0,0-5.337,1.6,1.185,1.185,0,0,1-1.567-.872,17.429,17.429,0,0,0-1.714-4.9c-.979-1.635-2.135-1.7-2.83-1.547a.548.548,0,0,0-.392.744,28.775,28.775,0,0,1,1.244,3.447,72.564,72.564,0,0,1-.45,7.256L424,185.464l7.335,10.605,3.232-4.789,6.933-3.055s1.3-1.655,1.165-2.213a1.744,1.744,0,0,0-.676-.921l.852-1.2A3.69,3.69,0,0,0,442.665,182.506Z",
    transform: "translate(-333.079 -115.087)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5124",
    "data-name": "Path 5124",
    d: "M441.016,178.949l-.147.1a4.411,4.411,0,0,0-.421.245l-1.586.872-2.35,1.273c-.45.235-.9.509-1.42.725a1.87,1.87,0,0,1-1.7,0,1.263,1.263,0,0,1-.519-.734,1.832,1.832,0,0,1,0-.862,2.468,2.468,0,0,1,.891-1.332,9.9,9.9,0,0,1,1.2-.8l1.067-.636,1.557-.911.431-.245.157-.078-.137.108-.421.264-1.528.979-1.058.656a10.323,10.323,0,0,0-1.175.793,2.36,2.36,0,0,0-.832,1.253,1.332,1.332,0,0,0,.47,1.43,1.429,1.429,0,0,0,.774.206,2.341,2.341,0,0,0,.783-.176c.5-.206.979-.48,1.41-.705l2.37-1.253,1.6-.823.4-.343C440.958,178.949,441.007,178.891,441.016,178.949Z",
    transform: "translate(-333.262 -115.232)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5125",
    "data-name": "Path 5125",
    d: "M441.983,182.2a1.472,1.472,0,0,1-.323.2l-.979.48c-.783.382-1.9.891-3.153,1.381a8.929,8.929,0,0,1-.93.343,1.959,1.959,0,0,1-.979,0,1.44,1.44,0,0,1-1.038-1.146,1.371,1.371,0,0,1,.245-.979.87.87,0,0,1,.2-.215l.078-.059a1.82,1.82,0,0,0-.225.3,1.488,1.488,0,0,0-.186.979,1.351,1.351,0,0,0,.979.979,1.733,1.733,0,0,0,.862,0,7.977,7.977,0,0,0,.911-.333c1.253-.5,2.36-.979,3.173-1.342l.979-.431a1.956,1.956,0,0,1,.392-.157Z",
    transform: "translate(-333.298 -115.349)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5126",
    "data-name": "Path 5126",
    d: "M442.378,185.267a1.817,1.817,0,0,1-.333.137l-.92.294-3.055.921c-.294.078-.588.176-.881.225a1.577,1.577,0,0,1-.881-.059.979.979,0,0,1-.568-.568,1.057,1.057,0,0,1,0-.7,1.488,1.488,0,0,1,.627-.744.979.979,0,0,1,.323-.147,3.444,3.444,0,0,1-.284.2,1.518,1.518,0,0,0-.558.734.979.979,0,0,0,0,.617.852.852,0,0,0,.5.47,1.439,1.439,0,0,0,.793,0,8.034,8.034,0,0,0,.862-.225c1.195-.353,2.282-.656,3.065-.872l.979-.255A2.031,2.031,0,0,1,442.378,185.267Z",
    transform: "translate(-333.321 -115.4)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5127",
    "data-name": "Path 5127",
    d: "M442.429,188.073a7.6,7.6,0,0,1-1.038.108l-2.526.137h-.715a3.174,3.174,0,0,1-.686,0A1.048,1.048,0,0,1,436.9,188a.637.637,0,0,1-.147-.539.911.911,0,0,1,.49-.617.461.461,0,0,1,.274-.069,1.957,1.957,0,0,0-.245.127.911.911,0,0,0-.411.578.539.539,0,0,0,.137.431.911.911,0,0,0,.49.255,3.62,3.62,0,0,0,.656,0h.715c.979,0,1.88-.078,2.526-.088A6.373,6.373,0,0,1,442.429,188.073Z",
    transform: "translate(-333.343 -115.444)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5128",
    "data-name": "Path 5128",
    d: "M435.694,185.686a8.977,8.977,0,0,0-1.763-.45,8.81,8.81,0,0,0-1.821.069,3.329,3.329,0,0,1,1.841-.235A3.457,3.457,0,0,1,435.694,185.686Z",
    transform: "translate(-333.247 -115.408)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5129",
    "data-name": "Path 5129",
    d: "M388.569,234.071l1.518-.392s.539-2.556,1.2-3.094,7.4-3.6,8.882-4.407,7.256-3.437,7.981-2.037c.823,1.577-1.528,2.879-2.81,3.486s-4.9,2.017-4.172,2.889,8.872.48,8.872.48l.979-1.371s1.792,1.7,1.6,3.183a6.561,6.561,0,0,1-.813,2.419h-.6a1.684,1.684,0,0,1,.059,1.743,15.667,15.667,0,0,1-1.606,2.017,6,6,0,0,1-3.829,2.791c-.343.1-13.778,1.263-13.778,1.263l-4.495.45Z",
    transform: "translate(-332.323 -116.211)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shield",
    transform: "translate(0.358 7.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5130",
    "data-name": "Path 5130",
    d: "M111.826,30.083,76.162,17,40.821,29.907c-4.5,2.184-8.461,3.5-8.461,7.834V59.186a82.581,82.581,0,0,0,11.634,42.686,73.072,73.072,0,0,0,32.521,29.407c14.434-4.808,25.206-17.627,31.8-28.594a82.62,82.62,0,0,0,11.634-42.7V40.708C119.944,34.558,116.772,31.562,111.826,30.083Z",
    transform: "translate(-0.671 -8.301)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(31.688 8.699)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5131",
    "data-name": "Path 5131",
    d: "M111.826,30.083,76.162,17,40.821,29.907c-4.5,2.184-8.461,3.5-8.461,7.834V59.186a82.581,82.581,0,0,0,11.634,42.686,73.072,73.072,0,0,0,32.521,29.407c14.434-4.808,25.206-17.627,31.8-28.594a82.62,82.62,0,0,0,11.634-42.7V40.708C119.944,34.558,116.772,31.562,111.826,30.083Z",
    transform: "translate(-32.359 -17)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5132",
    "data-name": "Path 5132",
    d: "M104.96,39.027,76.346,28.49,48.016,38.88c-3.613,1.753-6.786,2.81-6.786,6.257V62.353a66.217,66.217,0,0,0,9.332,34.274,58.6,58.6,0,0,0,26.068,23.62c11.585-3.858,20.222-14.15,25.51-22.944a66.256,66.256,0,0,0,9.332-34.274V47.6C111.511,42.621,108.926,40.212,104.96,39.027Z",
    transform: "translate(-0.855 -8.539)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5133",
    "data-name": "Path 5133",
    d: "M98.292,69.094H81.469V52.27H71.8V69.094H54.98v9.665H71.8V95.582h9.665V78.759H98.292Z",
    transform: "translate(-1.141 -9.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5134",
    "data-name": "Path 5134",
    d: "M129,117.409s.166-.235.5-.666l.274-.372c.1-.147.186-.313.284-.49a7.562,7.562,0,0,0,.637-1.263c.1-.255.215-.509.313-.793l.255-.911a6.248,6.248,0,0,0,.206-.979,9.887,9.887,0,0,0,.157-1.116,21.259,21.259,0,0,0-.245-5.405,48.609,48.609,0,0,0-4.965-13.964A108.766,108.766,0,0,0,115.758,74.8,168.345,168.345,0,0,0,99.875,56.96a193.217,193.217,0,0,0-20.858-17.8c-3.917-2.859-8-5.641-12.329-8.255a119.191,119.191,0,0,0-13.71-7.178,63.652,63.652,0,0,0-15.227-4.74,26.851,26.851,0,0,0-8.118-.2,15.179,15.179,0,0,0-3.917,1.136,11.1,11.1,0,0,0-3.3,2.409,11.2,11.2,0,0,0-2.037,3.506,15.609,15.609,0,0,0-.685,4.025,26.949,26.949,0,0,0,1.126,8.059,63.74,63.74,0,0,0,6.473,14.6,119.6,119.6,0,0,0,8.7,12.789c3.094,4.005,6.316,7.766,9.606,11.31A194.33,194.33,0,0,0,65.659,95.366a169.407,169.407,0,0,0,19.585,13.71,108.375,108.375,0,0,0,17.627,8.7,48.111,48.111,0,0,0,14.444,3.339,20.927,20.927,0,0,0,5.386-.362,11.182,11.182,0,0,0,1.1-.284,6.853,6.853,0,0,0,.979-.323l.881-.353.744-.411a6.717,6.717,0,0,0,1.185-.774c.166-.118.323-.225.45-.333l.343-.323c.392-.382.607-.568.607-.568l-.588.6-.333.323a4.493,4.493,0,0,1-.45.343,7.628,7.628,0,0,1-1.175.793l-.7.411-.881.362a5.1,5.1,0,0,1-.979.333,9.469,9.469,0,0,1-1.1.294,21.142,21.142,0,0,1-5.425.4,48.258,48.258,0,0,1-14.5-3.29,109.676,109.676,0,0,1-17.724-8.676,168.431,168.431,0,0,1-19.585-13.71,194.568,194.568,0,0,1-20.173-18.7c-3.3-3.545-6.532-7.315-9.636-11.33A119.165,119.165,0,0,1,27.028,52.71a64.131,64.131,0,0,1-6.522-14.689,27.076,27.076,0,0,1-1.126-8.147,15.609,15.609,0,0,1,.7-4.123,11.438,11.438,0,0,1,2.1-3.653,11.32,11.32,0,0,1,3.4-2.487,15.6,15.6,0,0,1,4.015-1.165,27.478,27.478,0,0,1,8.216.206,64,64,0,0,1,15.316,4.808,118.922,118.922,0,0,1,13.71,7.2c4.338,2.624,8.451,5.405,12.348,8.275a195.847,195.847,0,0,1,20.868,17.852,169.63,169.63,0,0,1,15.913,17.911,109.128,109.128,0,0,1,10.635,16.647,48.679,48.679,0,0,1,4.9,14.033,21.3,21.3,0,0,1,.215,5.425,8.124,8.124,0,0,1-.166,1.136,6.7,6.7,0,0,1-.215.979c-.1.323-.176.627-.264.911s-.225.548-.323.8a6.854,6.854,0,0,1-.656,1.263,5.191,5.191,0,0,1-.284.48l-.294.372Z",
    transform: "translate(-0.402 -8.327)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5135",
    "data-name": "Path 5135",
    d: "M148.419,70.355a6.764,6.764,0,0,0-.078-.832v-.46a3.068,3.068,0,0,0-.118-.548,7.648,7.648,0,0,0-.372-1.371c-.088-.245-.176-.519-.284-.793l-.421-.852a7.084,7.084,0,0,0-.519-.9c-.206-.294-.382-.637-.637-.979a21.387,21.387,0,0,0-3.78-3.868,48.747,48.747,0,0,0-12.995-7.119,109.365,109.365,0,0,0-18.988-5.278A170.626,170.626,0,0,0,86.5,44.61a193.134,193.134,0,0,0-27.419.607c-4.808.45-9.724,1.116-14.689,2.047A117.8,117.8,0,0,0,29.4,51.024a63.544,63.544,0,0,0-14.6,6.61A26.577,26.577,0,0,0,8.611,62.9a14.9,14.9,0,0,0-2.174,3.457,10.938,10.938,0,0,0-.852,4,11.124,11.124,0,0,0,.842,4.005A15.3,15.3,0,0,0,8.6,77.826a26.783,26.783,0,0,0,6.2,5.249,64.2,64.2,0,0,0,14.552,6.581,121.327,121.327,0,0,0,15,3.76c4.975.979,9.89,1.586,14.689,2.047a194.542,194.542,0,0,0,27.419.6A169.124,169.124,0,0,0,110.2,93.318a109.52,109.52,0,0,0,18.988-5.249,48.483,48.483,0,0,0,12.995-7.129,20.77,20.77,0,0,0,3.78-3.917,9.34,9.34,0,0,0,.636-.979,6.989,6.989,0,0,0,.519-.891c.147-.3.284-.588.421-.852a5.644,5.644,0,0,0,.284-.8,7.833,7.833,0,0,0,.372-1.361,3.12,3.12,0,0,1,.118-.558,2.4,2.4,0,0,0,0-.46,3.462,3.462,0,0,1,.078-.832v1.3a3.463,3.463,0,0,1-.108.558,7.449,7.449,0,0,1-.353,1.371c-.1.255-.176.529-.284.813l-.421.852a5.033,5.033,0,0,1-.519.911,8.816,8.816,0,0,1-.627.979,21.122,21.122,0,0,1-3.77,3.917,48.621,48.621,0,0,1-13.014,7.2,109.424,109.424,0,0,1-19.007,5.327,169.324,169.324,0,0,1-23.806,2.81,192.03,192.03,0,0,1-27.419-.568c-4.818-.45-9.744-1.116-14.689-2.047a118.493,118.493,0,0,1-15.041-3.76A64.161,64.161,0,0,1,14.7,83.34a27.1,27.1,0,0,1-6.267-5.327,15.433,15.433,0,0,1-2.223-3.545,10.116,10.116,0,0,1,0-8.236A15.374,15.374,0,0,1,8.434,62.7,27.1,27.1,0,0,1,14.7,57.37a64.4,64.4,0,0,1,14.562-6.61A118.491,118.491,0,0,1,44.3,47c4.975-.979,9.9-1.586,14.689-2.047a194.942,194.942,0,0,1,27.419-.568,169.256,169.256,0,0,1,23.767,2.791,108.442,108.442,0,0,1,19,5.327,48.473,48.473,0,0,1,13.083,7.168,21.182,21.182,0,0,1,3.76,3.917,9.9,9.9,0,0,1,.627.979,6.7,6.7,0,0,1,.519.911l.421.862c.108.274.186.548.284.8a7.734,7.734,0,0,1,.353,1.381,4.341,4.341,0,0,0,.108.558v.46C148.409,70.081,148.419,70.355,148.419,70.355Z",
    transform: "translate(-0.111 -8.864)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5136",
    "data-name": "Path 5136",
    d: "M122.823,10.372l-.705-.45-.392-.255c-.147-.088-.323-.157-.5-.245a8.03,8.03,0,0,0-1.312-.548l-.793-.264-.979-.186a6.855,6.855,0,0,0-.979-.137,10.517,10.517,0,0,0-1.136-.078,21.24,21.24,0,0,0-5.366.617,48.493,48.493,0,0,0-13.6,5.876,109.491,109.491,0,0,0-15.8,11.751A168.55,168.55,0,0,0,64.547,43.588,194.332,194.332,0,0,0,48.223,65.622c-2.546,4.074-5.073,8.373-7.384,12.887a119.95,119.95,0,0,0-6.218,14.16A64.356,64.356,0,0,0,30.9,108.2a26.93,26.93,0,0,0,.362,8.118,15.316,15.316,0,0,0,1.41,3.839A11.027,11.027,0,0,0,35.3,123.28a11.242,11.242,0,0,0,3.682,1.772,15.374,15.374,0,0,0,4.064.411A26.929,26.929,0,0,0,51,123.789a64.1,64.1,0,0,0,14.111-7.472,117.343,117.343,0,0,0,12.162-9.558C81.067,103.4,84.6,99.905,87.9,96.409a194.731,194.731,0,0,0,17.274-21.328,169.6,169.6,0,0,0,12.378-20.437A109.422,109.422,0,0,0,125,36.4a48.434,48.434,0,0,0,2.331-14.64,21.182,21.182,0,0,0-.734-5.357,10.481,10.481,0,0,0-.362-1.067,6.679,6.679,0,0,0-.392-.979q-.215-.441-.411-.852c-.147-.255-.313-.49-.45-.715a7.159,7.159,0,0,0-.862-1.126c-.127-.157-.245-.313-.362-.431l-.323-.294c-.411-.372-.607-.568-.607-.568s.215.176.627.548l.353.3c.118.118.235.274.372.421a7.512,7.512,0,0,1,.872,1.126c.147.225.313.46.46.725l.431.852a7.4,7.4,0,0,1,.4.979c.108.343.274.685.362,1.077a21.171,21.171,0,0,1,.774,5.376,48.589,48.589,0,0,1-2.291,14.689,108.218,108.218,0,0,1-7.423,18.283,169.928,169.928,0,0,1-12.348,20.486A192.757,192.757,0,0,1,88.137,96.586c-3.31,3.535-6.855,7.021-10.635,10.39a120.68,120.68,0,0,1-12.241,9.587,64.347,64.347,0,0,1-14.189,7.511,27.252,27.252,0,0,1-8.049,1.684,15.335,15.335,0,0,1-4.162-.411,11.614,11.614,0,0,1-3.76-1.792,11.575,11.575,0,0,1-2.713-3.222,15.394,15.394,0,0,1-1.44-3.917,27.262,27.262,0,0,1-.362-8.216A64.22,64.22,0,0,1,34.327,92.59,118.869,118.869,0,0,1,40.565,78.4c2.321-4.5,4.818-8.813,7.4-12.887a194.8,194.8,0,0,1,16.373-22.1A169.67,169.67,0,0,1,81.106,26.344,109.119,109.119,0,0,1,96.961,14.593a48.13,48.13,0,0,1,13.661-5.876,21.387,21.387,0,0,1,5.406-.6c.392,0,.764.069,1.126.088a6.62,6.62,0,0,1,1.038.147l.979.2c.294.088.558.186.813.274a7.325,7.325,0,0,1,1.312.558c.186.1.353.176.5.264l.392.255Z",
    transform: "translate(-0.631 -8.117)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5137",
    "data-name": "Path 5137",
    d: "M4.534,101.033a2.644,2.644,0,1,1-1.88-.785,2.654,2.654,0,0,1,1.88.785Z",
    transform: "translate(0 -10.028)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5138",
    "data-name": "Path 5138",
    d: "M157.508,16.944a2.654,2.654,0,1,1-2.654-2.654A2.654,2.654,0,0,1,157.508,16.944Z",
    transform: "translate(-3.158 -8.245)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5139",
    "data-name": "Path 5139",
    d: "M21.721,109.986a.676.676,0,1,1-.676-.676A.676.676,0,0,1,21.721,109.986Z",
    transform: "translate(-0.423 -10.216)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5140",
    "data-name": "Path 5140",
    d: "M36.431,33.986a.676.676,0,1,1-.676-.676A.676.676,0,0,1,36.431,33.986Z",
    transform: "translate(-0.728 -8.639)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5141",
    "data-name": "Path 5141",
    d: "M143.971,70.9a.676.676,0,1,1-.676-.676A.676.676,0,0,1,143.971,70.9Z",
    transform: "translate(-2.959 -9.405)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5142",
    "data-name": "Path 5142",
    d: "M153.551,38.776a.676.676,0,1,1-.676-.676A.676.676,0,0,1,153.551,38.776Z",
    transform: "translate(-3.158 -8.739)",
    fill: "#e8505b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character-2",
    "data-name": "Character",
    transform: "translate(0 178.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4802",
    "data-name": "Path 4802",
    d: "M233.42,401.109a.3.3,0,1,1,.042.513.309.309,0,0,1-.042-.513",
    transform: "translate(-129.307 -170.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4803",
    "data-name": "Path 4803",
    d: "M300.742,105.78l10.78,4.842s-16.865,24-20.316,27.87-37.476,8.672-37.476,8.672l-1.63-14.216,28.987-4.919Z",
    transform: "translate(-134.895 -82.387)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4804",
    "data-name": "Path 4804",
    d: "M301.914,148.955c-.07,0-.141-.85-.506-2.171a15.461,15.461,0,0,0-.836-2.256,16.021,16.021,0,0,0-1.49-2.53,16.387,16.387,0,0,0-1.953-2.2,15.751,15.751,0,0,0-1.89-1.483c-1.152-.752-1.947-1.082-1.918-1.145a1.833,1.833,0,0,1,.576.19,9.784,9.784,0,0,1,1.476.738,12.924,12.924,0,0,1,1.982,1.455,14.607,14.607,0,0,1,2.024,2.228,15.189,15.189,0,0,1,1.5,2.607,12.88,12.88,0,0,1,.773,2.333,10.2,10.2,0,0,1,.26,1.63A2.235,2.235,0,0,1,301.914,148.955Z",
    transform: "translate(-147.148 -91.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4805",
    "data-name": "Path 4805",
    d: "M290.373,146.22a6.527,6.527,0,0,1-1.082.372c-.7.218-1.722.506-2.987.85-2.537.7-6.065,1.567-9.986,2.389s-7.505,1.448-10.105,1.855c-1.3.2-2.354.344-3.085.429a7.805,7.805,0,0,1-1.138.1,6.327,6.327,0,0,1,1.117-.239l3.064-.541c2.586-.457,6.149-1.11,10.07-1.94s7.449-1.658,9.993-2.284l3.022-.7A8.03,8.03,0,0,1,290.373,146.22Z",
    transform: "translate(-137.835 -94.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4806",
    "data-name": "Path 4806",
    d: "M316.866,108c.077.07-4.28,5.13-9.74,11.3s-9.937,11.124-10.007,11.054,4.28-5.123,9.733-11.3S316.8,107.936,316.866,108Z",
    transform: "translate(-148.278 -83.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4807",
    "data-name": "Path 4807",
    d: "M305.668,132.28a.3.3,0,1,1,.042.52.309.309,0,0,1-.042-.52",
    transform: "translate(-150.783 -90.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4808",
    "data-name": "Path 4808",
    d: "M280.55,148.565a.316.316,0,0,1,.457.225.309.309,0,0,1-.408.288.3.3,0,0,1-.07-.492",
    transform: "translate(-143.317 -95.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4809",
    "data-name": "Path 4809",
    d: "M292.628,145.889a.3.3,0,1,1,.042.513.3.3,0,0,1-.042-.513",
    transform: "translate(-146.906 -94.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4810",
    "data-name": "Path 4810",
    d: "M312.52,124.59a.3.3,0,1,1,.049.52.309.309,0,0,1-.07-.5",
    transform: "translate(-152.822 -87.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4811",
    "data-name": "Path 4811",
    d: "M319.71,116.449a.3.3,0,1,1,.042.513.309.309,0,0,1-.042-.513",
    transform: "translate(-154.959 -85.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(124.674 46.829)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4812",
    "data-name": "Path 4812",
    d: "M282.546,139.369c.084.5-4.287,1.616-9.761,2.5s-9.972,1.2-10.056.7,4.294-1.623,9.768-2.509S282.469,138.87,282.546,139.369Z",
    transform: "translate(-262.728 -139.131)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4813",
    "data-name": "Path 4813",
    d: "M270.091,150.435a.309.309,0,0,1,.45.225.3.3,0,1,1-.478-.2",
    transform: "translate(-140.202 -95.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4814",
    "data-name": "Path 4814",
    d: "M247.78,141.353a7.73,7.73,0,0,1,8.334,2.452,9.8,9.8,0,0,1,1.658,8.742c-.836,2.972-4.8,6.992-7.484,8.109",
    transform: "translate(-133.611 -92.853)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4815",
    "data-name": "Path 4815",
    d: "M334.681,100.1a22.121,22.121,0,0,0,2.375-3.844,7.442,7.442,0,0,0,.654-4.413,4.533,4.533,0,0,0-2.684-3.4,3.3,3.3,0,0,0-3.949,1.3l2.86-5.657c.351-.7.7-1.56.239-2.192a1.483,1.483,0,0,0-1.947-.2,4.336,4.336,0,0,0-1.307,1.694l-4.216,7.934q-1.862-2.923-3.738-5.847c-.372-.6-.914-1.265-1.609-1.159a1.265,1.265,0,0,0-.928,1.251,3.64,3.64,0,0,0,.471,1.6c1.1,2.312,3.071,7.554,3.071,7.554Z",
    transform: "translate(-155.208 -75.145)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4816",
    "data-name": "Path 4816",
    d: "M251.081,160.243c-.063-.056.963-.829,2.185-2.438a10.73,10.73,0,0,0,1.63-3.106,11.054,11.054,0,0,0,.429-4.265,15.516,15.516,0,0,0-2.488-7.379,5.475,5.475,0,0,0-1.574-1.75,4.034,4.034,0,0,0-.794-.344h.232a1.869,1.869,0,0,1,.632.218,5.067,5.067,0,0,1,1.715,1.722,14.989,14.989,0,0,1,2.642,7.5,11.076,11.076,0,0,1-.471,4.4,10.358,10.358,0,0,1-1.75,3.155,12.435,12.435,0,0,1-1.686,1.75,3.213,3.213,0,0,1-.7.541Z",
    transform: "translate(-134.41 -92.846)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4817",
    "data-name": "Path 4817",
    d: "M320.861,103.589A73.339,73.339,0,0,0,330,108.55c1.258.59,2.811,1.124,3.949.323a2.649,2.649,0,0,0,.871-2.705,5.888,5.888,0,0,0-1.49-2.572,16.464,16.464,0,0,0-7.73-4.842,6.873,6.873,0,0,0-3.261-.253,3.162,3.162,0,0,0-2.4,2.031,2.67,2.67,0,0,0,.9,3.057",
    transform: "translate(-155.013 -80.197)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4818",
    "data-name": "Path 4818",
    d: "M334.565,108.28c-.056,0-.471-.836-1.405-2.038a13.26,13.26,0,0,0-10.309-5.074c-1.532,0-2.467.183-2.481.112a2.375,2.375,0,0,1,.646-.183,11.245,11.245,0,0,1,1.827-.19,12.649,12.649,0,0,1,5.9,1.293,12.839,12.839,0,0,1,4.624,3.886,11.032,11.032,0,0,1,.956,1.567A2.309,2.309,0,0,1,334.565,108.28Z",
    transform: "translate(-155.19 -80.938)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4819",
    "data-name": "Path 4819",
    d: "M229.764,215.665c.105.2-1.251,1.174-3.71,2.214a31.693,31.693,0,0,1-4.462,1.462,34.074,34.074,0,0,1-11.44.843,30.7,30.7,0,0,1-4.631-.794c-2.586-.7-4.069-1.405-3.991-1.644s1.672.049,4.216.372c1.279.169,2.811.3,4.5.387a54.466,54.466,0,0,0,5.509-.084c1.947-.155,3.788-.422,5.46-.7a43.591,43.591,0,0,0,4.392-1.04C228.113,215.96,229.645,215.419,229.764,215.665Z",
    transform: "translate(-119.86 -115.036)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4820",
    "data-name": "Path 4820",
    d: "M229.583,221.157c.077.225-1.223.935-3.514,1.687a39.957,39.957,0,0,1-18.39,1.335c-2.347-.415-3.731-.928-3.689-1.167.1-.534,5.819.288,12.832-.253S229.407,220.644,229.583,221.157Z",
    transform: "translate(-120.592 -116.656)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4821",
    "data-name": "Path 4821",
    d: "M194.5,73.551s-23.19,4.287-22.9,25.045,19.936,17.273,25.635,16.542c2.586-.33,7.73-1.061,12.6-1.764,10.316-1.483,18-6.5,18.622-16.865a19.368,19.368,0,0,0-.126-3.661C226.868,81.815,216.636,68.632,194.5,73.551Z",
    transform: "translate(-110.963 -72.491)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4822",
    "data-name": "Path 4822",
    d: "M224.347,98.787l-29.592,6.282a5.734,5.734,0,0,1-6.809-4.427h0a5.741,5.741,0,0,1,4.42-6.809l29.6-6.275a5.734,5.734,0,0,1,6.8,4.427h0a5.734,5.734,0,0,1-4.42,6.8Z",
    transform: "translate(-115.786 -76.933)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_523",
    "data-name": "Ellipse 523",
    cx: 1.841,
    cy: 1.841,
    r: 1.841,
    transform: "translate(81.12 20.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_524",
    "data-name": "Ellipse 524",
    cx: 1.841,
    cy: 1.841,
    r: 1.841,
    transform: "translate(101.794 15.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4823",
    "data-name": "Path 4823",
    d: "M212.638,85.046a15.944,15.944,0,0,1-.991-2.108,20.514,20.514,0,0,0-2.881-4.708,10.415,10.415,0,0,0-4.336-3.268,19.049,19.049,0,0,0-2.221-.562,1.953,1.953,0,0,1,.625,0,7.427,7.427,0,0,1,1.679.33,9.922,9.922,0,0,1,4.533,3.282,18.061,18.061,0,0,1,2.811,4.842c.267.7.457,1.209.583,1.588A2.108,2.108,0,0,1,212.638,85.046Z",
    transform: "translate(-120.064 -73.051)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4824",
    "data-name": "Path 4824",
    d: "M218.1,125.311c-.042-.049.625-.7,1.441-1.911a12.859,12.859,0,0,0,2.031-5.284,21.785,21.785,0,0,0-.049-5.72,20.709,20.709,0,0,1-.316-2.375,1.94,1.94,0,0,1,.2.618c.1.4.239.984.379,1.715a19.5,19.5,0,0,1,.155,5.819,12.108,12.108,0,0,1-2.185,5.376,10.89,10.89,0,0,1-1.152,1.342A2.256,2.256,0,0,1,218.1,125.311Z",
    transform: "translate(-124.787 -83.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(71.781 29.867)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4825",
    "data-name": "Path 4825",
    d: "M230.53,117.767a18.559,18.559,0,0,0-9.016-2.741,44.391,44.391,0,0,0-9.494.654c-7.266,1.089-14.7,2.811-20.59,7.21a11.243,11.243,0,0,0-3.97,4.673s3.113,1.279,9.339.864,19.072-2.649,19.072-2.649,6.563-1.11,10.281-3.879S230.53,117.767,230.53,117.767Z",
    transform: "translate(-187.46 -114.993)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4826",
    "data-name": "Path 4826",
    d: "M229.67,90.725a4.59,4.59,0,0,1,.267,1.061,6.711,6.711,0,0,1-.281,3.127,7.2,7.2,0,0,1-3.141,3.8,20.083,20.083,0,0,1-6.247,2.108l-16.746,3.661-4.842,1.054c-1.651.344-3.317.78-5.081,1.012a8.011,8.011,0,0,1-5.291-.907,7.554,7.554,0,0,1-2.614-9.929,8.179,8.179,0,0,1,3.963-3.64,13.569,13.569,0,0,1,2.53-.7l2.488-.583,4.828-1.131,8.918-2.108c2.811-.6,5.362-1.405,7.765-1.869a25.4,25.4,0,0,1,3.464-.478,13.352,13.352,0,0,1,3.12.112,9.775,9.775,0,0,1,4.575,1.911,6.845,6.845,0,0,1,1.954,2.46,4.414,4.414,0,0,1,.3.759,1.406,1.406,0,0,1,.077.274,8.538,8.538,0,0,0-.436-1,7.1,7.1,0,0,0-1.975-2.375,9.747,9.747,0,0,0-4.525-1.82,12.649,12.649,0,0,0-3.071-.077,23.893,23.893,0,0,0-3.422.492c-2.382.492-4.919,1.293-7.73,1.911l-8.91,2.108L194.78,91.1l-2.488.59a13.908,13.908,0,0,0-2.474.7,7.857,7.857,0,0,0-3.788,3.471,7.2,7.2,0,0,0,2.488,9.452,7.6,7.6,0,0,0,5.06.857c1.722-.218,3.4-.654,5.053-.991l4.842-1.047,16.76-3.584a20.03,20.03,0,0,0,6.191-2.031,7.027,7.027,0,0,0,3.092-3.64,6.745,6.745,0,0,0,.351-3.064C229.776,91.09,229.649,90.725,229.67,90.725Z",
    transform: "translate(-114.889 -76.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4827",
    "data-name": "Path 4827",
    d: "M172.06,112.612a5.166,5.166,0,0,1,1.131-.984,20.315,20.315,0,0,1,3.1-1.89,20.049,20.049,0,0,1,3.387-1.293,5.123,5.123,0,0,1,1.476-.3c0,.112-2.192.7-4.7,1.918S172.13,112.711,172.06,112.612Z",
    transform: "translate(-111.101 -83.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4828",
    "data-name": "Path 4828",
    d: "M206.3,78.08a.3.3,0,1,1,.042.52.309.309,0,0,1-.042-.52",
    transform: "translate(-121.243 -74.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4829",
    "data-name": "Path 4829",
    d: "M211.54,85.729a.3.3,0,1,1,.042.513.309.309,0,0,1-.042-.513",
    transform: "translate(-122.802 -76.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4830",
    "data-name": "Path 4830",
    d: "M179.861,107.143a.3.3,0,0,1,.45.218.3.3,0,1,1-.471-.2",
    transform: "translate(-113.379 -82.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4831",
    "data-name": "Path 4831",
    d: "M173.328,110.639a.3.3,0,1,1,.042.513.3.3,0,0,1-.042-.513",
    transform: "translate(-111.441 -83.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(62.809 1.274)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4832",
    "data-name": "Path 4832",
    d: "M201.682,74.407c.056.26-2.031.857-5.327,1.911a43.031,43.031,0,0,0-12.017,5.622,23.962,23.962,0,0,0-5.13,5.038,20.113,20.113,0,0,0-2.811,5.158c-1.152,3.169-1.012,5.369-1.321,5.376-.119,0-.288-.527-.365-1.525a13.218,13.218,0,0,1,.45-4.216,18.489,18.489,0,0,1,2.677-5.734,22.874,22.874,0,0,1,5.432-5.544,30.61,30.61,0,0,1,6.788-3.626,41.952,41.952,0,0,1,5.931-1.8C199.461,74.315,201.612,74.175,201.682,74.407Z",
    transform: "translate(-174.692 -74.305)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(63.888 30.189)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4833",
    "data-name": "Path 4833",
    d: "M179.722,119.99c-.3.394-1.644-.155-2.621-1.539s-1.068-2.811-.6-2.98,1.258.773,2.108,1.918S180.045,119.59,179.722,119.99Z",
    transform: "translate(-176.228 -115.452)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4834",
    "data-name": "Path 4834",
    d: "M228.621,137.067c1.405.4,1.314,20.751,1.019,31.138-.162,5.566-.583,11.37-3.422,16.163A19.457,19.457,0,0,1,210.85,193.5c-7.449.5-14.813-3.106-19.908-8.559s-8.109-12.586-9.733-19.873-1.94-14.8-2.249-22.255C178.988,142.815,203.07,129.8,228.621,137.067Z",
    transform: "translate(-113.152 -91.033)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(66.917 54.65)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4835",
    "data-name": "Path 4835",
    d: "M180.554,157.231a55.042,55.042,0,0,0,3.092,19.606,36.214,36.214,0,0,0,11.1,15.734,34.434,34.434,0,0,0,4.919,3.071,21.474,21.474,0,0,0,4.624,1.729c2.621.752,4.167-2.488,4.68-5.165a9.892,9.892,0,0,0-2.108-7.667,22.81,22.81,0,0,0-6.163-5.306,74.309,74.309,0,0,1-6.809-4.526,31.628,31.628,0,0,1-8.327-11.194,94.2,94.2,0,0,1-4.7-13.253",
    transform: "translate(-180.539 -150.26)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4836",
    "data-name": "Path 4836",
    d: "M204.991,199.673a.3.3,0,0,1,.45.218.3.3,0,1,1-.471-.2",
    transform: "translate(-120.849 -110.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4837",
    "data-name": "Path 4837",
    d: "M217.829,199.163a.288.288,0,1,1,.042.513.309.309,0,0,1-.063-.5",
    transform: "translate(-124.671 -110.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4838",
    "data-name": "Path 4838",
    d: "M231.844,185.913a.309.309,0,0,1,.457.225.3.3,0,1,1-.478-.211",
    transform: "translate(-128.834 -106.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4839",
    "data-name": "Path 4839",
    d: "M225.408,153.189a.3.3,0,1,1,.042.513.3.3,0,0,1-.042-.513",
    transform: "translate(-126.923 -96.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4840",
    "data-name": "Path 4840",
    d: "M238.549,158.55a.3.3,0,1,1,.042.52.309.309,0,0,1-.063-.5",
    transform: "translate(-130.831 -98.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4841",
    "data-name": "Path 4841",
    d: "M190.448,195.879a.3.3,0,1,1,.042.513.3.3,0,0,1-.042-.513",
    transform: "translate(-116.53 -109.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4842",
    "data-name": "Path 4842",
    d: "M188.328,184.979a.3.3,0,1,1,.042.513.3.3,0,0,1-.042-.513",
    transform: "translate(-115.9 -105.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4843",
    "data-name": "Path 4843",
    d: "M187.4,175.135a.309.309,0,0,1,.45.218.3.3,0,1,1-.478-.2",
    transform: "translate(-115.62 -102.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4844",
    "data-name": "Path 4844",
    d: "M186.468,164.649a.3.3,0,1,1,.042.513.3.3,0,0,1-.042-.513",
    transform: "translate(-115.347 -99.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    d: "M246.357,155.985a.309.309,0,0,1,.45.225.316.316,0,0,1-.408.3.309.309,0,0,1-.07-.5",
    transform: "translate(-133.151 -97.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4846",
    "data-name": "Path 4846",
    d: "M233.949,198.17a.3.3,0,1,1,.042.52.309.309,0,0,1-.063-.5",
    transform: "translate(-129.463 -109.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4847",
    "data-name": "Path 4847",
    d: "M235.4,208.519a.3.3,0,1,1,.042.513.3.3,0,0,1-.042-.513",
    transform: "translate(-129.893 -112.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(68.175 51.411)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4848",
    "data-name": "Path 4848",
    d: "M224.029,145.721c.07.218-2.108,1.188-5.833,2.2a62.307,62.307,0,0,1-6.627,1.405,69.5,69.5,0,0,1-16.563.555,62.352,62.352,0,0,1-6.7-.942c-3.781-.759-6.029-1.581-5.973-1.806.119-.555,9.36,1.574,20.913,1.138S223.874,145.194,224.029,145.721Z",
    transform: "translate(-182.329 -145.652)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4849",
    "data-name": "Path 4849",
    d: "M199.011,193.361a2.3,2.3,0,0,1-.379-.3c-.246-.2-.6-.52-1.026-.949a14.357,14.357,0,0,1-2.972-4.216,22.3,22.3,0,0,1-1.174-3.359c-.365-1.223-.7-2.537-1.1-3.921-.7-2.769-1.462-5.84-2.108-9.086a146.281,146.281,0,0,1-2.333-16.774c-.169-2.164-.26-3.914-.3-5.123l-.035-1.405a2.581,2.581,0,0,1,0-.485,2.169,2.169,0,0,1,.063.485c0,.351.056.815.1,1.405.091,1.2.218,2.951.422,5.109a167.243,167.243,0,0,0,2.431,16.725c.639,3.24,1.349,6.324,2.066,9.072.365,1.405.7,2.7,1.061,3.921a23.188,23.188,0,0,0,1.124,3.338,14.9,14.9,0,0,0,2.811,4.216c.415.443.745.773.977.991A2.64,2.64,0,0,1,199.011,193.361Z",
    transform: "translate(-115.713 -94.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4850",
    "data-name": "Path 4850",
    d: "M227.126,180.8c.1,0,.857,5.587,1.687,12.494s1.405,12.53,1.328,12.544-.857-5.58-1.687-12.494S227.035,180.814,227.126,180.8Z",
    transform: "translate(-127.468 -104.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4851",
    "data-name": "Path 4851",
    d: "M212.08,135.92a5.14,5.14,0,0,1,.5.5c.3.337.745.836,1.272,1.462,1.054,1.244,2.5,2.973,4.076,4.919.2.239.386.478.583.7l.07.091a.267.267,0,0,1,.084.105c0,.056.042.105.056.155v.119c0,.155.049.309.063.457.063.59.1,1.152.126,1.694.049,1.082.077,2.052.091,2.867s0,1.483,0,1.94a3.231,3.231,0,0,1-.042.7,19.019,19.019,0,0,1-.225-2.635c-.049-.843-.105-1.806-.169-2.86-.042-.534-.077-1.1-.148-1.673a4.2,4.2,0,0,0-.063-.429v-.1a.112.112,0,0,1,0-.063c0-.035-.091-.084-.126-.148l-.583-.7c-1.574-1.925-2.98-3.682-3.991-4.968-.5-.639-.906-1.167-1.174-1.532A2.557,2.557,0,0,1,212.08,135.92Z",
    transform: "translate(-122.998 -91.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4852",
    "data-name": "Path 4852",
    d: "M218.374,195.9a4.92,4.92,0,0,1-.878.183c-.569.091-1.405.211-2.424.337-2.045.253-4.919.527-8.039.7s-6.008.176-8.074.126c-1.033,0-1.869-.056-2.445-.091a4.012,4.012,0,0,1-.892-.091,3.935,3.935,0,0,1,.9-.049h2.438c2.066,0,4.919-.077,8.053-.239s5.98-.394,8.032-.583l2.438-.218A3.584,3.584,0,0,1,218.374,195.9Z",
    transform: "translate(-118.105 -109.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4853",
    "data-name": "Path 4853",
    d: "M245.2,157.27a3.743,3.743,0,0,1-.478.344,14.571,14.571,0,0,1-1.405.773,30.22,30.22,0,0,1-4.968,1.911,39.087,39.087,0,0,1-5.186,1.152,10.542,10.542,0,0,1-2.193.2,16.282,16.282,0,0,1,2.15-.457c1.328-.267,3.148-.7,5.13-1.251a42.066,42.066,0,0,0,4.954-1.792Q244.18,157.663,245.2,157.27Z",
    transform: "translate(-128.613 -97.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_525",
    "data-name": "Ellipse 525",
    cx: 8.236,
    cy: 8.236,
    r: 8.236,
    transform: "translate(85.668 68.112) rotate(-45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_526",
    "data-name": "Ellipse 526",
    cx: 6.001,
    cy: 6.001,
    rx: 6.001,
    ry: 6.001,
    transform: "translate(89.523 64.738) rotate(-21.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4854",
    "data-name": "Path 4854",
    d: "M225.587,169a6.159,6.159,0,0,1-.127-.984c-.063-.618-.141-1.5-.218-2.579l.077.119-3.211-1.574h.169c-.928.611-1.925,1.279-2.98,1.968-.07.148.105-.2.084-.162h0v.914a5.64,5.64,0,0,0,.049.914c0,.59.063,1.174.091,1.729l-.091-.148,3.176,1.637h-.07c.907-.576,1.658-1.04,2.193-1.363a5.964,5.964,0,0,1,.864-.485,4.838,4.838,0,0,1-.738.569c-.506.358-1.244.878-2.171,1.511l-.063.042-.077-.035-3.211-1.553-.091-.042v-.1q-.056-.843-.105-1.729c0-.3-.042-.6-.056-.914v-.914h0s.155-.309.084-.162l2.987-1.954.084-.056.091.042,3.176,1.637.07.035v.077c.049,1.124.07,2.024.084,2.642a4.862,4.862,0,0,1-.07.914Z",
    transform: "translate(-125.079 -99.591)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(65.836 43.748)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4855",
    "data-name": "Path 4855",
    d: "M179,142.781S203.124,129.6,228.661,137C228.633,137.033,217.7,147.384,179,142.781Z",
    transform: "translate(-179 -134.746)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4856",
    "data-name": "Path 4856",
    d: "M234.227,376.865a.309.309,0,0,1,.45.225.288.288,0,1,1-.471-.2",
    transform: "translate(-129.544 -162.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4857",
    "data-name": "Path 4857",
    d: "M219.366,241.611c.436,17.16,2.185,34.335,6.556,50.933.752,2.846,1.63,5.8,3.675,7.927s5.622,3.071,7.983,1.321c2.031-1.5,2.488-4.294,2.769-6.8a526.882,526.882,0,0,0,3.64-55.381s.534-14.146-9.438-14.139S219.106,231.1,219.366,241.611Z",
    transform: "translate(-125.161 -117.969)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(94.768 107.926)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4858",
    "data-name": "Path 4858",
    d: "M226.579,227.188c1.244-1.511,3.767-1.405,5.284-.169a7.7,7.7,0,0,1,2.424,5.186c.7,6.149-2.319,12.059-3.394,18.158-1.033,5.868-.246,11.9-.534,17.856s-1.588,12.031-6.254,15.748c0,0-4.511-22.944-3.872-31.707C220.7,245.867,226.579,227.188,226.579,227.188Z",
    transform: "translate(-220.172 -226.074)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4859",
    "data-name": "Path 4859",
    d: "M231.176,260.61a4.735,4.735,0,0,1,.077.534l.169,1.532c.141,1.405.337,3.3.583,5.622.492,4.771,1.216,11.349,2.15,18.608s1.9,13.8,2.635,18.545c.358,2.34.654,4.216.864,5.622.1.639.176,1.145.232,1.525a3.1,3.1,0,0,1,.049.541,3.989,3.989,0,0,1-.127-.527c-.07-.38-.169-.885-.3-1.511-.246-1.321-.583-3.233-.984-5.622-.794-4.729-1.8-11.286-2.741-18.545s-1.616-13.851-2.045-18.622c-.211-2.389-.372-4.329-.464-5.664-.042-.64-.07-1.153-.1-1.539A2.413,2.413,0,0,1,231.176,260.61Z",
    transform: "translate(-128.672 -128.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4860",
    "data-name": "Path 4860",
    d: "M203.747,254.372c4.659,2.277,11.307.429,14.539-4.287s4.216-10.541,5.158-16.163c.316-1.89.569-4.027-.611-5.544-1.342-1.729-3.879-1.806-6.071-1.736l-20.836.7s-7.575,2.171-7.575,6.746S197.38,251.259,203.747,254.372Z",
    transform: "translate(-115.943 -118.312)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4861",
    "data-name": "Path 4861",
    d: "M232.929,337.47a6.193,6.193,0,0,0-5.017,3.97,18.119,18.119,0,0,0-1.054,6.62c-.485,13.661-.956,27.343-.2,41,.162,2.952.457,6.093,2.263,8.433s5.678,3.317,7.73,1.173c1.167-1.223,1.405-3.036,1.588-4.715q2.656-24.419,5.306-48.846c.2-1.841.372-3.837-.562-5.432a5.9,5.9,0,0,0-4.448-2.586,17.463,17.463,0,0,0-5.292.457",
    transform: "translate(-127.213 -151.137)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4862",
    "data-name": "Path 4862",
    d: "M231.43,402.209a.819.819,0,0,1-.035-.162l-.063-.485c-.049-.422-.126-1.054-.2-1.862-.155-1.616-.337-3.963-.464-6.866-.281-5.8-.225-13.844.049-22.7s.52-16.865.7-22.691a19.621,19.621,0,0,1,1.181-6.774,9.514,9.514,0,0,1,.878-1.651l.3-.394a.855.855,0,0,1,.112-.126.265.265,0,0,1-.077.148l-.267.408a12.06,12.06,0,0,0-.815,1.673,20.378,20.378,0,0,0-1.047,6.732c-.155,5.833-.365,13.836-.6,22.684s-.372,16.865-.155,22.684c.1,2.9.232,5.242.344,6.866.056.78.1,1.405.134,1.862v.485A.611.611,0,0,1,231.43,402.209Z",
    transform: "translate(-128.469 -151.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4863",
    "data-name": "Path 4863",
    d: "M228.505,426.936a16.062,16.062,0,0,1-.19-4.181,5.4,5.4,0,0,1,1.883-3.64,6.915,6.915,0,0,1,6.219-.6,5.418,5.418,0,0,1,2.677,4.111l1.047,5.095",
    transform: "translate(-127.807 -175.215)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4864",
    "data-name": "Path 4864",
    d: "M227.851,430.37l12.129.127s8.932,2.017,8.735,2.734-21.215-.141-21.215-.141Z",
    transform: "translate(-127.582 -178.881)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4865",
    "data-name": "Path 4865",
    d: "M221.814,227.56a8.426,8.426,0,0,1,.408,1.1,13.043,13.043,0,0,1,.387,1.314c.126.513.3,1.1.408,1.764s.26,1.405.337,2.178.155,1.63.2,2.516a32.592,32.592,0,0,1-.33,5.783,31.7,31.7,0,0,1-1.405,5.622c-.33.829-.618,1.63-.984,2.333-.169.358-.323.7-.5,1.033l-.527.914a16.86,16.86,0,0,1-.97,1.532,10.029,10.029,0,0,1-.815,1.1,6.981,6.981,0,0,1-.766.885,8.214,8.214,0,0,1,.654-.97,13.56,13.56,0,0,0,.759-1.131c.274-.45.618-.949.914-1.546.162-.3.33-.6.5-.921s.316-.7.478-1.026c.351-.7.625-1.5.942-2.319a33.892,33.892,0,0,0,1.405-5.551,34.735,34.735,0,0,0,.351-5.713c-.042-.878-.063-1.722-.162-2.495s-.183-1.5-.3-2.164-.246-1.244-.351-1.764-.225-.963-.33-1.321A6.356,6.356,0,0,1,221.814,227.56Z",
    transform: "translate(-124.538 -118.59)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4866",
    "data-name": "Path 4866",
    d: "M237.179,285.755a.309.309,0,0,1,.45.225.3.3,0,0,1-.408.288.309.309,0,0,1-.063-.5",
    transform: "translate(-130.423 -135.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4867",
    "data-name": "Path 4867",
    d: "M239.717,307.149a.3.3,0,1,1,.042.513.309.309,0,0,1-.07-.5",
    transform: "translate(-131.177 -142.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4868",
    "data-name": "Path 4868",
    d: "M234.637,263.919a.3.3,0,1,1,.042.513.309.309,0,0,1-.07-.5",
    transform: "translate(-129.667 -129.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4869",
    "data-name": "Path 4869",
    d: "M234.631,356.463a.3.3,0,0,1,.45.218.3.3,0,1,1-.478-.2",
    transform: "translate(-129.66 -156.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4870",
    "data-name": "Path 4870",
    d: "M239.258,424.69a5.619,5.619,0,0,1-1.56.583,19.045,19.045,0,0,1-3.984.7,19.449,19.449,0,0,1-4.034-.176,5.881,5.881,0,0,1-1.63-.394,45.18,45.18,0,0,0,5.622.2A45.577,45.577,0,0,0,239.258,424.69Z",
    transform: "translate(-127.745 -177.192)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(99.033 188.036)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4871",
    "data-name": "Path 4871",
    d: "M226.24,379.578a18.574,18.574,0,0,0,6.423-9.838,56.042,56.042,0,0,0,1.757-11.792,53.953,53.953,0,0,1,1.813-11.778,5.235,5.235,0,0,0,.372-2.544c-.3-1.37-1.687-2.164-2.958-2.741-1.574-.7-3.556-1.3-4.919-.225-1.012.8-1.237,2.235-1.37,3.514-1.223,11.946-1.124,23.928-1.019,35.909",
    transform: "translate(-226.24 -340.074)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_527",
    "data-name": "Ellipse 527",
    cx: 8.629,
    cy: 8.629,
    rx: 8.629,
    ry: 8.629,
    transform: "translate(100.832 175.63)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4872",
    "data-name": "Path 4872",
    d: "M245.678,332.93a2.348,2.348,0,0,1-.45.534,7.425,7.425,0,0,1-1.518,1.138,11.349,11.349,0,0,1-6.057,1.363,22.905,22.905,0,0,1-6.1-1.237c-.759-.253-1.356-.471-1.771-.633a2.662,2.662,0,0,1-.632-.288,22.893,22.893,0,0,1,2.481.668,25.725,25.725,0,0,0,6.036,1.124,11.946,11.946,0,0,0,5.924-1.216A15.693,15.693,0,0,0,245.678,332.93Z",
    transform: "translate(-128.072 -149.914)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4873",
    "data-name": "Path 4873",
    d: "M105.184,131.618s-1.7-6.943-2.6-7.266-11.778,1.223-11.778,1.223-3.514-4.919-4.083-5.58-1.715.977-1.335,1.715,2.965,7.941,4.582,8.18a39.476,39.476,0,0,0,5.664-.07l1.321,4.518Z",
    transform: "translate(-85.313 -86.567)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4874",
    "data-name": "Path 4874",
    d: "M157.445,164.675c-6.866,2.495-11.244,3.767-18.116,6.325-3.8,1.405-8.65,2.987-12.248,3.907a11.718,11.718,0,0,1-7.456-.2,12.78,12.78,0,0,1-4.729-4.3c-6.093-8.06-9.48-18.271-11.855-28.109l8.25-1.553L126.2,161.625l27.1-9.269,4.462,11.054a.808.808,0,0,1-.323,1.265Z",
    transform: "translate(-90.583 -92.78)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4875",
    "data-name": "Path 4875",
    d: "M177.974,150a9.627,9.627,0,0,0-3.282,16.64c1.117.928,2.7,1.637,4.02.232a3.843,3.843,0,0,0,.85-1.581A20.569,20.569,0,0,0,177.974,150Z",
    transform: "translate(-110.838 -95.533)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4876",
    "data-name": "Path 4876",
    d: "M174.93,153.474s0-.063.105-.155a1.791,1.791,0,0,1,.387-.372.773.773,0,0,1,.386-.148,1.187,1.187,0,0,1,.485.091,1.089,1.089,0,0,1,.443.344c.119.148.232.309.358.464a14.489,14.489,0,0,1,2.593,5.833,13.732,13.732,0,0,1-.169,6.381,3.689,3.689,0,0,1-1.012,1.673,1.441,1.441,0,0,1-.625.358,3.318,3.318,0,0,0,.527-.464,3.816,3.816,0,0,0,.864-1.644,14.624,14.624,0,0,0,.056-6.233,15.552,15.552,0,0,0-2.445-5.748c-.239-.33-.408-.7-.7-.773a.7.7,0,0,0-.7,0C175.127,153.3,174.979,153.5,174.93,153.474Z",
    transform: "translate(-111.954 -96.365)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4877",
    "data-name": "Path 4877",
    d: "M133,170.46a2.249,2.249,0,0,1,.119.6,9.494,9.494,0,0,1,.07,1.68,11.676,11.676,0,0,1-.379,2.467,12.559,12.559,0,0,1-1.174,2.811,12.874,12.874,0,0,1-3.753,4.055,10.02,10.02,0,0,1-1.405.85c-.358.176-.562.26-.569.232s.745-.45,1.862-1.293a14.054,14.054,0,0,0,3.584-4.027,13.693,13.693,0,0,0,1.167-2.741,12.328,12.328,0,0,0,.443-2.4C133.043,171.338,132.93,170.467,133,170.46Z",
    transform: "translate(-97.381 -101.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4878",
    "data-name": "Path 4878",
    d: "M161.8,160.869c.035.1-5.713,2.347-12.832,5.024s-12.937,4.771-12.972,4.68,5.713-2.34,12.839-5.024S161.769,160.777,161.8,160.869Z",
    transform: "translate(-100.381 -98.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4879",
    "data-name": "Path 4879",
    d: "M106.86,142.66a2.321,2.321,0,0,1,.148.323l.351.949c.3.829.7,2.024,1.293,3.514,1.124,2.93,2.811,6.929,4.919,11.244,1.082,2.108,2.171,4.146,3.2,5.945s2.024,3.387,2.9,4.687c.422.661.829,1.244,1.188,1.75s.661.956.921,1.307.436.6.59.822a1.5,1.5,0,0,1,.19.3,1.908,1.908,0,0,1-.246-.253l-.6-.836c-.281-.337-.6-.766-.977-1.272s-.794-1.075-1.237-1.729c-.907-1.286-1.9-2.874-2.973-4.659s-2.15-3.8-3.233-5.952a105.9,105.9,0,0,1-4.87-11.286c-.541-1.476-.935-2.691-1.195-3.514l-.281-.977a1.622,1.622,0,0,1-.091-.365Z",
    transform: "translate(-91.718 -93.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4880",
    "data-name": "Path 4880",
    d: "M143.4,173.837a.3.3,0,1,0-.443-.267.309.309,0,0,0,.415.281",
    transform: "translate(-102.45 -102.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4881",
    "data-name": "Path 4881",
    d: "M127.043,178.667a.3.3,0,1,0-.443-.267.316.316,0,0,0,.422.281",
    transform: "translate(-97.586 -103.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4882",
    "data-name": "Path 4882",
    d: "M119.643,167.057a.3.3,0,1,0-.443-.267.3.3,0,0,0,.443.267",
    transform: "translate(-95.387 -100.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4883",
    "data-name": "Path 4883",
    d: "M152.976,170.474a.288.288,0,1,0-.436-.267.3.3,0,0,0,.436.267",
    transform: "translate(-105.298 -101.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4884",
    "data-name": "Path 4884",
    d: "M163.949,166.979a.3.3,0,1,1,.042.513.309.309,0,0,1-.063-.5",
    transform: "translate(-108.654 -100.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4885",
    "data-name": "Path 4885",
    d: "M101.878,140.384a59.93,59.93,0,0,0,8.376-1.181c1.1-.232,2.382-.632,2.734-1.7a2.15,2.15,0,0,0-.7-2.185,4.758,4.758,0,0,0-2.214-.956,13.3,13.3,0,0,0-7.386.569,5.5,5.5,0,0,0-2.249,1.405,2.558,2.558,0,0,0-.583,2.481,2.171,2.171,0,0,0,2.059,1.56",
    transform: "translate(-89.604 -90.801)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4886",
    "data-name": "Path 4886",
    d: "M112.718,136.851c0,.063-.7-.3-1.911-.618a10.843,10.843,0,0,0-9.135,1.658c-1.012.7-1.532,1.3-1.574,1.258s.091-.176.323-.443a8.226,8.226,0,0,1,1.1-1.019,10.189,10.189,0,0,1,9.388-1.7,8.151,8.151,0,0,1,1.405.569C112.57,136.718,112.732,136.83,112.718,136.851Z",
    transform: "translate(-89.705 -91.225)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4887",
    "data-name": "Path 4887",
    d: "M197.011,336.393c-2.235.239-4.005,2.143-4.771,4.259a18.627,18.627,0,0,0-.668,6.669c.33,13.668.668,27.357,2.228,40.934.337,2.944.815,6.057,2.755,8.292s5.868,2.98,7.779.7c1.089-1.286,1.223-3.113,1.307-4.8q1.209-24.539,2.41-49.078c.091-1.848.148-3.844-.885-5.383a5.9,5.9,0,0,0-4.6-2.319,17.468,17.468,0,0,0-5.256.766",
    transform: "translate(-116.896 -150.728)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4888",
    "data-name": "Path 4888",
    d: "M182.756,241.9c.436,17.16,2.185,34.328,6.556,50.926.752,2.853,1.63,5.812,3.675,7.934s5.622,3.071,7.983,1.314c2.031-1.5,2.488-4.294,2.769-6.8a526.6,526.6,0,0,0,3.64-55.374s.534-14.146-9.445-14.139S182.482,231.389,182.756,241.9Z",
    transform: "translate(-114.277 -118.055)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(69.552 112.308)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4889",
    "data-name": "Path 4889",
    d: "M191.555,297.234c-.253.035-1.047-3.584-2.108-9.473s-2.452-14.054-3.514-23.19c-.534-4.54-.935-8.9-1.258-12.832a53.692,53.692,0,0,1-.19-10.632,15.552,15.552,0,0,1,2.3-6.873l.7-.914a6.026,6.026,0,0,1,.576-.6c.33-.309.52-.45.569-.408s-.056.267-.281.64a7.987,7.987,0,0,0-.422.7c-.148.3-.33.6-.52.956a17.176,17.176,0,0,0-1.63,6.634,59.965,59.965,0,0,0,.583,10.351c.443,3.935.864,8.25,1.405,12.782,1.054,9.051,2.221,17.224,2.972,23.19S191.815,297.2,191.555,297.234Z",
    transform: "translate(-184.288 -232.31)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4890",
    "data-name": "Path 4890",
    d: "M199.138,303.023a.775.775,0,0,1-.063-.19l-.141-.583-.527-2.228c-.443-1.947-1.026-4.764-1.665-8.264-1.265-7.027-2.593-16.767-3.514-27.589-.485-5.411-.857-10.541-1.195-15.263-.162-2.347-.316-4.575-.464-6.662a46.375,46.375,0,0,1-.162-5.833,16.077,16.077,0,0,1,.9-4.736,11.111,11.111,0,0,1,1.764-3.176,8.231,8.231,0,0,1,1.658-1.588,4.337,4.337,0,0,1,.7-.422A9.839,9.839,0,0,0,194.2,228.6a11.293,11.293,0,0,0-1.687,3.169,15.95,15.95,0,0,0-.836,4.68,46.268,46.268,0,0,0,.2,5.79c.155,2.108.323,4.322.5,6.662.351,4.694.738,9.838,1.223,15.263.928,10.815,2.207,20.562,3.408,27.568.611,3.514,1.152,6.324,1.553,8.285.19.949.344,1.7.457,2.242.042.239.084.436.112.583A.743.743,0,0,1,199.138,303.023Z",
    transform: "translate(-116.844 -118.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4891",
    "data-name": "Path 4891",
    d: "M198.292,397.521a4.161,4.161,0,0,1-.1-.59l-.211-1.686c-.176-1.462-.4-3.591-.661-6.219-.513-5.256-1.11-12.53-1.553-20.576s-.625-15.34-.7-20.625V339.87a4.815,4.815,0,0,1,0-.59,3.233,3.233,0,0,1,.042.59c0,.422,0,.991.042,1.7.035,1.511.077,3.64.134,6.254.119,5.277.351,12.565.787,20.611s1.054,15.305,1.511,20.541c.225,2.6.415,4.722.548,6.226.056.7.105,1.272.141,1.694A3.208,3.208,0,0,1,198.292,397.521Z",
    transform: "translate(-117.937 -151.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_528",
    "data-name": "Ellipse 528",
    cx: 8.629,
    cy: 8.629,
    rx: 8.629,
    ry: 8.629,
    transform: "translate(73.903 175.827)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4892",
    "data-name": "Path 4892",
    d: "M195.6,428.611a36.116,36.116,0,0,1,.408-6.648,5.376,5.376,0,0,1,2.4-3.317,6.9,6.9,0,0,1,6.24.309,5.411,5.411,0,0,1,2.045,4.462l.288,5.193",
    transform: "translate(-118.099 -175.217)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4893",
    "data-name": "Path 4893",
    d: "M195.742,430.6l12.129-.112s8.967,1.848,8.791,2.565-21.222.281-21.222.281Z",
    transform: "translate(-118.051 -178.917)",
    fill: "#717888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4894",
    "data-name": "Path 4894",
    d: "M196.288,269.03a.3.3,0,1,1,.042.52.309.309,0,0,1-.042-.52",
    transform: "translate(-118.267 -130.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4895",
    "data-name": "Path 4895",
    d: "M195.043,250.589a.3.3,0,1,1,.042.513.316.316,0,0,1-.042-.513",
    transform: "translate(-117.9 -125.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4896",
    "data-name": "Path 4896",
    d: "M197.828,291.688a.3.3,0,1,1,.042.513.3.3,0,0,1-.042-.513",
    transform: "translate(-118.724 -137.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4897",
    "data-name": "Path 4897",
    d: "M200.948,317.149a.3.3,0,1,1,.042.513.3.3,0,0,1-.042-.513",
    transform: "translate(-119.652 -145.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4898",
    "data-name": "Path 4898",
    d: "M197.414,355.985a.316.316,0,0,1,.457.225.3.3,0,1,1-.478-.211",
    transform: "translate(-118.598 -156.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4899",
    "data-name": "Path 4899",
    d: "M199.377,376.075a.309.309,0,0,1,.45.225.316.316,0,0,1-.408.3.309.309,0,0,1-.07-.5",
    transform: "translate(-119.185 -162.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4900",
    "data-name": "Path 4900",
    d: "M199.608,398.569a.3.3,0,1,1,.042.513.3.3,0,0,1-.042-.513",
    transform: "translate(-119.253 -169.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4901",
    "data-name": "Path 4901",
    d: "M207.734,332.549a2.515,2.515,0,0,1-.506.513,10.7,10.7,0,0,1-1.588,1.152,12.551,12.551,0,0,1-12.445.3,10.292,10.292,0,0,1-1.637-1.075,2.379,2.379,0,0,1-.527-.485c.042-.056.822.611,2.284,1.328a13.043,13.043,0,0,0,12.2-.288C206.94,333.2,207.691,332.492,207.734,332.549Z",
    transform: "translate(-116.74 -149.8)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4902",
    "data-name": "Path 4902",
    d: "M206.654,425.38a5.489,5.489,0,0,1-1.525.583,17.619,17.619,0,0,1-3.9.633,17.4,17.4,0,0,1-3.935-.26,5.368,5.368,0,0,1-1.574-.429,39.558,39.558,0,0,0,5.5.323A38,38,0,0,0,206.654,425.38Z",
    transform: "translate(-118.134 -177.398)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4903",
    "data-name": "Path 4903",
    d: "M221.155,99.56a2.417,2.417,0,0,1,0,1.567,3.661,3.661,0,0,1-4.807,2.41,3.752,3.752,0,0,1-1.405-.991,2.361,2.361,0,0,1-.7-1.405,7.235,7.235,0,0,0,.878,1.223,3.865,3.865,0,0,0,1.342.85,3.514,3.514,0,0,0,3.6-.822,3.724,3.724,0,0,0,.836-1.349,6.941,6.941,0,0,0,.253-1.483Z",
    transform: "translate(-123.64 -80.538)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10008",
    "data-name": "Group 10008",
    transform: "translate(298.592 455.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4746",
    "data-name": "Path 4746",
    d: "M2555.4,1439.35l3.311-8.521s8.06,5.583,9.386,12.662a18.783,18.783,0,0,0-7.007,1.914C2560.493,1442.067,2555.4,1439.35,2555.4,1439.35Z",
    transform: "translate(-2511.393 -1406.434)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4736",
    "data-name": "Path 4736",
    d: "M2226.281,2637.42s.381,2.2.568,4.374a1.489,1.489,0,0,1-1.409,1.624c-2.843.121-8.923.355-11.1.256a.487.487,0,0,1-.421-.671h0a1.085,1.085,0,0,1,.548-.588l10.043-4.706Z",
    transform: "translate(-2192.785 -2532.071)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4737",
    "data-name": "Path 4737",
    d: "M2357.977,2612.525l-.306,2.63s-1.759.835-2.96-.1l.729-2.931Z",
    transform: "translate(-2324.168 -2508.468)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4738",
    "data-name": "Path 4738",
    d: "M2360.7,1881.41c.135.686.709,34.264-2.811,49.314a.513.513,0,0,0,.294.594,8.584,8.584,0,0,0,2.867.594.865.865,0,0,0,.856-.631c1.007-3.489,5.829-20.983,6.458-37.693.7-18.671,0-.635,0-.635l-.413-11.54Z",
    transform: "translate(-2327.12 -1826.783)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4739",
    "data-name": "Path 4739",
    d: "M2514.966,2654.51a16.182,16.182,0,0,1,1.193,4.059.912.912,0,0,1-.79,1.1c-.939.094-2.384.215-3.541.207a.906.906,0,0,1-.885-1.017,7.785,7.785,0,0,1,1.761-4.219Z",
    transform: "translate(-2469.913 -2548.014)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4740",
    "data-name": "Path 4740",
    d: "M2539.671,2601.954l-.715,3.976a2.477,2.477,0,0,1-2.105.148l.341-4.279Z",
    transform: "translate(-2494.088 -2498.84)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4741",
    "data-name": "Path 4741",
    d: "M2409.82,1870.928c2.879,17.713-.625,43.786-1.807,48.889a.786.786,0,0,1-.63.6,5.145,5.145,0,0,1-2.252-.092.727.727,0,0,1-.514-.671c-.159-4.125.127-29.451-2.556-39.459a2.28,2.28,0,0,0-.86-1.255l-5.208-3.773-.4-6.1Z",
    transform: "translate(-2362.305 -1815.271)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4742",
    "data-name": "Path 4742",
    d: "M2160.988,1376.448a79.655,79.655,0,0,1,18.151,2.31c2.571,15.3.449,32.949.449,32.949-6.68,1.786-14.217-1.092-14.217-1.092-1.111-6.4-6.292-24.394-6.292-24.394a28.042,28.042,0,0,1-10.55-3.413,19.03,19.03,0,0,0,3.658-7.8A28.451,28.451,0,0,0,2160.988,1376.448Z",
    transform: "translate(-2131.821 -1354.359)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4743",
    "data-name": "Path 4743",
    d: "M1954.28,1194.037a1.63,1.63,0,0,1,1.921-.55c1.27,5.469,7.928,9.9,14.769,12.07a19.032,19.032,0,0,1-3.657,7.8C1955.96,1206.848,1954.28,1194.037,1954.28,1194.037Z",
    transform: "translate(-1950.604 -1184.907)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4744",
    "data-name": "Path 4744",
    d: "M1903.379,1076.616c-.089.287.939.725,1.543-.451.021-.563.358-2.977.027-3.436a44.568,44.568,0,0,0-5.166-5.509.838.838,0,0,0-.1,1.149l1.654,1.756a8.263,8.263,0,0,0-.966,1.946,2.4,2.4,0,0,0,.231,1.74c.291.537.687,1.226,1.061,1.769A2.268,2.268,0,0,0,1903.379,1076.616Z",
    transform: "translate(-1899.497 -1067.22)",
    fill: "#f47960"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4745",
    "data-name": "Path 4745",
    d: "M1933.021,1127.53l1.508,1.3.473,1.3-1.342,1.52a17.961,17.961,0,0,0-.788-3.131C1932.536,1127.962,1932.71,1127.7,1933.021,1127.53Z",
    transform: "translate(-1930.462 -1123.484)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4747",
    "data-name": "Path 4747",
    d: "M2433.767,1623.461s9.05,5.214,12.1.762a3.549,3.549,0,0,0,.629-2.719,18.785,18.785,0,0,1,7.008-1.914,9.918,9.918,0,0,1-1.042,6.7c-5.349,9.975-19.9-.551-19.9-.551Z",
    transform: "translate(-2396.804 -1582.53)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4748",
    "data-name": "Path 4748",
    d: "M2152.266,1510.8l-4.939-17.583a.508.508,0,0,0-.425-.369c-.9-.106-3.489-.4-6.482-.663a72.184,72.184,0,0,0-10.3-.348.515.515,0,0,0-.412.738c1.424,2.935,7.277,14.874,10.208,18.786a.5.5,0,0,0,.407.2l11.459-.109a.513.513,0,0,0,.481-.652Z",
    transform: "translate(-2114.215 -1463.275)",
    fill: "#aea8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4751",
    "data-name": "Path 4751",
    d: "M2363.964,1628.93s.688-2.885.41-3.908-.815-2.338-2.607-2.047a25.772,25.772,0,0,0-3.907,1.062,1.03,1.03,0,0,0,1.469.9l-.845.666s.121,1.067,1.271.5l-.786.884a.909.909,0,0,0,1.342.314C2361.16,1626.74,2361.564,1629.277,2363.964,1628.93Z",
    transform: "translate(-2327.107 -1585.65)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4752",
    "data-name": "Path 4752",
    d: "M2386.769,1290l2.746,8.095a.3.3,0,0,1-.131.352,6.35,6.35,0,0,1-6.694-.459,1.376,1.376,0,0,1-.621-.981l-.889-7.007Z",
    transform: "translate(-2348.862 -1275.053)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4753",
    "data-name": "Path 4753",
    d: "M2338.413,1178.27s-3.015,5.786-2.629,8.123,4.123,2.17,7.386.268l2.281-6.247Z",
    transform: "translate(-2306.48 -1170.819)",
    fill: "#f47960"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4754",
    "data-name": "Path 4754",
    d: "M2358.584,1125.1a.24.24,0,0,1-.1-.349,6.241,6.241,0,0,0,.839-1.816s.542-.353-1.379-.823-4.788-1.2-5.389-2.864c-.588-1.626.955-5.714,3.417-2.457a.231.231,0,0,0,.371,0,2.387,2.387,0,0,1,2.937-.973,2.258,2.258,0,0,1,1.515,2.179.234.234,0,0,0,.275.243,2.68,2.68,0,0,1,3.15,1.5c.643,1.441.225,2.256-.156,2.655a.241.241,0,0,0,.1.4,1.428,1.428,0,0,1,.99,1.632c-.082,1.512-1.74,1.379-2.214,1.31a.234.234,0,0,0-.208.075c-.4.457-2.229,2.4-4.2,2.63a.239.239,0,0,1-.248-.318l.855-2.532a.242.242,0,0,0-.128-.3Z",
    transform: "translate(-2322.039 -1112.322)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4755",
    "data-name": "Path 4755",
    d: "M2429.835,1252.662s2.147-1.5,2.3-.237-1.933,1.832-2.968,1.36Z",
    transform: "translate(-2393.632 -1239.527)",
    fill: "#f47960"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionPageHealthInsurancePartImage);
export default __webpack_public_path__ + "static/media/Solution Page Health Insurance Part Image.b3bab6f99588d407906c183aebd3ca5c.svg";
export { ForwardRef as ReactComponent };